import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import { useLocation } from 'react-router-dom';

import SupplierConstantsList from "./common/SupplierConstants";
import CustomerConstantsList from "./common/CustomerConstants";
import LogisticsConstantsList from "./common/LogisticsConstants";
import PLMConstantsList from "./common/PLMConstants";
import PDMConstantsList from "./common/PDMConstants";
import AP_AUTOConstantsList from "./common/AP_AUTOConstants";

import Page404 from "./Pages/404Page";
import Login from "./Pages/Login/LoginV1";
import Register from "./Pages/Login/Register";
import Company from "./Pages/Settings/Company";
import Profile from "./Pages/Settings/Profile";

// APP Dashboard
import AppLandingPage from "./Pages/AppLandingPage";

// Supplier_App START -----------------------------------------------------------------------------------------------------------------
import HOME from "./Pages/supplier_app";
import HOME_INTRO from "./Pages/supplier_app/HomeIntro/HomeIntro";
import DASHBOARD from "./Pages/supplier_app/Dashboard";
import INBOX from "./Pages/supplier_app/Inbox";
import OUTBOX from "./Pages/supplier_app/Outbox";
import RESET_PASSWORD from "./Pages/ResetPassword";
// SUPPLIER
import SELF_REGISTRATION from "./Pages/SelfRegistration";
import SUPPILER_REGISTRATION from "./Pages/supplier_app/Supplier/SupplierMaster/SupplierRegistration";
import SUPPILER_LIST from "./Pages/supplier_app/Supplier/SupplierMaster/SupplierList";
import SUPPILER_MASS_UPLOAD from "./Pages/supplier_app/Supplier/SupplierMassUpload";
import SUPPLIER_MASTER_CREATE from "./Pages/supplier_app/Supplier/SupplierMaster/SupplierMasterCreate";
import SUPPLIER_DETAILED_PAGE_CREATE from "./Pages/supplier_app/Supplier/SupplierMaster/SupplierDetailedPage";
import SUPPLIER_DETAILED_PAGE_WORKFLOW from "./Pages/supplier_app/Supplier/SupplierMaster/SupplierDetailedPageWorkflow";

// VENDOR
import VENDOR_REGISTRATION from "./Pages/supplier_app/Vendor/VendorRegistrationV1";
import VENDOR_REGISTRATIONV2 from "./Pages/supplier_app/Vendor/VendorRegistrationV2";
import VENDOR_SELFREGISTRATIONV1 from "./Pages/supplier_app/Vendor/VendorSelfRegistrationV1";

import VENDOR_LIST from "./Pages/supplier_app/Vendor/VendorList";
import VENDOR_DETAILPAGE_WORKFLOW from "./Pages/supplier_app/Vendor/VendorDetailedPageWorkflow";
import VENDOR_DETAILS from "./Pages/supplier_app/Vendor/VendorDetailedPage";

import VENDOR_PREASSESMENT_FORM from "./Pages/supplier_app/Vendor/PreAssesmentForm";
import VENDOR_PREASSESMENT_FORM_DETAILS from "./Pages/supplier_app/Vendor/PreAssesmentFormDetails";

// SOURCING
import SOURCING_PURCHASE_REQUISITION_LIST from "./Pages/supplier_app/Sourcing/PR/PurchaseRequisitionList";
import SOURCING_VENDOR_REQUEST_FOR_QUOTATION from "./Pages/supplier_app/Sourcing/Supplier/VendorRequestForQuotationList";
import SOURCING_VENDOR_RFQ_DETAILS from "./Pages/supplier_app/Sourcing/Supplier/VendorRFQDetails";
import SOURCING_VENDOR_QUOTATION_LIST from "./Pages/supplier_app/Sourcing/Supplier/VendorQuotationList";
import SOURCING_BUYER_REQUEST_FOR_QUOTATION from "./Pages/supplier_app/Sourcing/Buyer/BuyerRequestForQuotationList";
import SOURCING_BUYER_RFQ_DETAILS from "./Pages/supplier_app/Sourcing/Buyer/BuyerRFQDetails";
import SOURCING_BUYER_QUOTATION_LIST from "./Pages/supplier_app/Sourcing/Buyer/BuyerQuotationList";
import SOURCING_CREATE_RFQ from "./Pages/supplier_app/Sourcing/Buyer/CreateRFQ";
import SOURCING_CREATE_MANUAL_RFQ from "./Pages/supplier_app/Sourcing/Buyer/CreateManualRFQ";
import SOURCING_CREATE_QUOTATION from "./Pages/supplier_app/Sourcing/Supplier/CreateQuotation";
import SOURCING_QUOTATION_DETAILS from "./Pages/supplier_app/Sourcing/Supplier/QuotationDetailPage";
import SOURCING_TECH_EVALUATION_REQUEST_FOR_QUOTATION from "./Pages/supplier_app/Sourcing/TechEvaluation/TechEvaluationRFQList";
import SOURCING_TECH_EVALUATION_DETAILS from "./Pages/supplier_app/Sourcing/TechEvaluation/TechEvaluationRFQDetails";
// SOURCING
import SOURCING_PURCHASE_REQUISITION_CREATE from "./Pages/supplier_app/Sourcing/PR/CreatePR";
import SOURCING_PURCHASE_REQUISITION_DETAILED_PAGE from "./Pages/supplier_app/Sourcing/PR/PurchaseRequisitionDetailedPage";
import SOURCING_COMMERCIAL_EVALUATION from "./Pages/supplier_app/Sourcing/CommEvaluation/CommercialEvaluation";
import SOURCING_TECHNICAL_EVALUATION from "./Pages/supplier_app/Sourcing/TechEvaluation/TechnicalEvaluation";
import SOURCING_PURCHASE_ORDER_CREATION from "./Pages/supplier_app/Sourcing/CreatePO";
import SOURCING_COMMERCIAL_EVALUATION_DETAILS from "./Pages/supplier_app/Sourcing/CommEvaluation/CommercialEvaluationDetails";

// purchase
import SOURCING_PURCHASE_CREATE_PO from "./Pages/supplier_app/Sourcing/Purchase/PurchaseOrderCreation";
import SOURCING_PURCHASE_ORDER_CREATION2 from "./Pages/supplier_app/Sourcing/Purchase/PurchaseOrderCreation2";

import SOURCING_PURCHASE_REQUISITION_CREATIONPR from "./Pages/supplier_app/Sourcing/Purchase/PurchaseRequisitionCreationPR";

// POCOLLABRATION
import POCOLLABRATION_PURCHASE_ORDER_LIST from "./Pages/supplier_app/POCollabration/PO/PurchaseOrderList";
import POCOLLABRATION_SERVICE_PURCHASE_ORDER_LIST from "./Pages/supplier_app/POCollabration/PO/ServicePurchaseOrderList";
import POCOLLABRATION_PURCHASE_ORDER_CREATION from "./Pages/supplier_app/POCollabration/PO/CreatePO";
import POCOLLABRATION_PURCHASE_ORDER_DETAIL_PAGE from "./Pages/supplier_app/POCollabration/PO/PurchaseOrderDetailPage";
import POCOLLABRATION_SERVICE_ENTRY_SHEET from "./Pages/supplier_app/POCollabration/SES/ServiceEntrySheetList";
import POCOLLABRATION_INVOICE from "./Pages/supplier_app/POCollabration/INVOICE/InvoiceList";
import POCOLLABRATION_INVOICE_DETIAILS from "./Pages/supplier_app/POCollabration/INVOICE/InvoiceDetails";
import POCOLLABRATION_PAYMENT_LIST from "./Pages/supplier_app/POCollabration/PAYMENT/PaymentList";
import POCOLLABRATION_ASN from "./Pages/supplier_app/POCollabration/ASN/ASNList";
import POCOLLABRATION_ASN_DETAIL_PAGE from "./Pages/supplier_app/POCollabration/ASN/ASNDetailPage";
import POCOLLABRATION_ASN_CREATION from "./Pages/supplier_app/POCollabration/ASN/CreateASN";
import POCOLLABRATION_SA_ASN_CREATION from "./Pages/supplier_app/POCollabration/ASN/CreateSAASN";
import POCOLLABRATION_GRN_CREATION from "./Pages/supplier_app/POCollabration/GRN/CreateGRN";
import POCOLLABRATION_GRN_DETAILS from "./Pages/supplier_app/POCollabration/GRN/GRNDetails";
import QUALITY_INSPECTION_CREATION from "./Pages/supplier_app/POCollabration/QualityInspection/QualityInspectionCreation";
import QUALITY_INSPECTION_LIST from "./Pages/supplier_app/POCollabration/QualityInspection/QualityInspectionList";
import QUALITY_INSPECTION_DETAILS from "./Pages/supplier_app/POCollabration/QualityInspection/QualityInspectionDetails";
import POCOLLABRATION_GOODS_RECEIVED_NOTE from "./Pages/supplier_app/POCollabration/GRN/GoodsReceivedNoteList";
import POCOLLABRATION_SES_CREATION from "./Pages/supplier_app/POCollabration/SES/CreateSES";
import POCOLLABRATION_INVOICE_CREATION from "./Pages/supplier_app/POCollabration/INVOICE/CreateInvoice";
import POCOLLABRATION_INVOICE_CREATION_SES from "./Pages/supplier_app/POCollabration/INVOICE/CreateInvoiceSES";
import POCOLLABRATION_SCHEDULING_AGREEMENT from "./Pages/supplier_app/POCollabration/PO/SchedulingAgreement";
import POCOLLABRATION_SERVICE_ENTRY_DETAILS from "./Pages/supplier_app/POCollabration/SES/ServiceEntrySheetDetail";
// SAPREPROCESS
import SAPREPROCESS_GRN_REPROCESS from "./Pages/supplier_app/SAPReprocess/GRNReprocess";
import SAPREPROCESS_SES_REPROCESS from "./Pages/supplier_app/SAPReprocess/SESReprocess";
import SAPREPROCESS_INVOICE_REPROCESS from "./Pages/supplier_app/SAPReprocess/InvoiceReprocess";
// ADMIN_MANAGE
import ADMIN_MANAGE_USER_LIST from "./Pages/supplier_app/Admin/ManageUserList";
import ADMIN_MANAGE_ROLE from "./Pages/supplier_app/Admin/ManageRole";
import ADMIN_MANAGE_ADD_USER from "./Pages/supplier_app/Admin/ManageAddUser";
import ADMIN_MANAGE_EDIT_USER from "./Pages/supplier_app/Admin/ManageEditUser";
import ADMIN_MANAGE_USER_LIST_DETAILS from "./Pages/supplier_app/Admin/ManageUserDetails";
// AUCTION_REVERSE_AUCTION
import AUCTION_REVERSE_AUCTION_LIST from "./Pages/supplier_app/Auction/ReverseAuction";
import AUCTION_REVERSE_AUCTION_CREATION from "./Pages/supplier_app/Auction/CreateAuction";
import AUCTION_REVERSE_AUCTION_HISTORY from "./Pages/supplier_app/Auction/ReverseAuctionHistory";
import AUCTION_FORWARD_AUCTION_LIST from "./Pages/supplier_app/Auction/ForwardAuction";
import AUCTION_FORWARD_AUCTION_HISTORY from "./Pages/supplier_app/Auction/ForwardAuctionHistory";
// CONTRACTMANAGEMENT_CONTRACT
import CONTRACTMANAGEMENT_CONTRACT_GENERATE_LIST from "./Pages/supplier_app/ContractManagement/ContractList";
import CONTRACTMANAGEMENT_CONTRACT_REVIEW_LIST from "./Pages/supplier_app/ContractManagement/ContractReviewer";
import CONTRACTMANAGEMENT_CONTRACT_DRAFT_TO_FINAL_LIST from "./Pages/supplier_app/ContractManagement/ContractDrafttoFinal";
import CONTRACTMANAGEMENT_MONITORING_LIST from "./Pages/supplier_app/ContractManagement/ContractMonitoring";
// GATEPASS
import GATEPASS_GATEPASS_LIST from "./Pages/supplier_app/GatePass/GatepassList";
import GATEPASS_GATEPASS_CREATE from "./Pages/supplier_app/GatePass/GatepassCreation";
import GATEPASS_GATEPASS_DETAIL_PAGE from "./Pages/supplier_app/GatePass/GatepassDetailPage";
// USER_MANUAL
import USER_MANUAL_BUYER_MANUAL from "./Pages/supplier_app/UserManual/BuyerManual";
import USER_MANUAL_SUPPLIER_MANUAL from "./Pages/supplier_app/UserManual/SupplierManual";
// DELEGATION
import DELEGATION_TASK from "./Pages/supplier_app/Delegation/DelegationList";
import DELEGATION_USER from "./Pages/supplier_app/Delegation/DelegationModal";
//SINGLE SOURCING
import SINGLESOURCING_SINGLE_SOURCING_CREATION from "./Pages/supplier_app/SingleSourcing/CreateSingleSource";
import SINGLESOURCING_SINGLE_SOURCING_LIST from "./Pages/supplier_app/SingleSourcing/SingleSourceList";
import SINGLESOURCING_SINGLE_SOURCING_DETAILS from "./Pages/supplier_app/SingleSourcing/SingleSourceDetails";
//ADVANCE_PAYMENT_ADVANCE
import ADVANCE_PAYMENT_ADVANCE_PAYMENT_REQUEST_CREATION from "./Pages/supplier_app/AdvancePayment/AdvancePaymentRequestCreate";
import ADVANCE_PAYMENT_ADVANCE_PAYMENT_REQUEST_LIST from "./Pages/supplier_app/AdvancePayment/AdvancePaymentRequestList";
import ADVANCE_PAYMENT_ADVANCE_PAYMENT_REQUEST_DETAILS from "./Pages/supplier_app/AdvancePayment/AdvancePaymentRequestDetails";
//GHG - GREEN HOUS GAS
import GHG_SCOPE1_CREATION from "./Pages/supplier_app/GHG/CreateGHGScop1";
//REPORTS
import SUPPLIER_REPORTS from "./Pages/supplier_app/Report/SupplierReports";
import SUPPLIER_REPORT_DETAILS from "./Pages/supplier_app/Report/ReportsDetail/SupplierReportsDetails";

/* MATERIAL_CATALOG */
import MATERIAL_CATALOG_LIST from "./Pages/supplier_app/MaterialCatalog/MaterialCatalog";
import MATERIAL_CATALOG_MASTER from "./Pages/supplier_app/MaterialCatalog/MaterialCatalogMaster";
import MATERIAL_CATALOG_SHOPWISE from "./Pages/supplier_app/MaterialCatalogShopwies/MaterialCatalogShopwise";

//CATEGORY
import CATEGORY_LIST from "./Pages/supplier_app/Category/CategoryList";
import CREATE_CATEGORY from "./Pages/supplier_app/Category/CreateCategory";
import CATEGORY_DETAILS from "./Pages/supplier_app/Category/CategoryDetails";

//INVOICE DOWN PAYMENT
import INVOICE_DOWN_PAYMENT_LIST from "./Pages/supplier_app/InvoiceDownPayment/InvoiceDownPaymentList";
import INVOICE_DOWN_PAYMENT_CREATE from "./Pages/supplier_app/InvoiceDownPayment/InvoiceDownPaymentCreate";

//SAP PO
import SAP_PURCHASE_ORDER_LIST from "./Pages/supplier_app/POCollabration/PoExtract/PurchaseOrderExtractList";
import SAP_PURCHASE_ORDER_DETAIL_PAGE from "./Pages/supplier_app/POCollabration/PoExtract/PurchaseOrderExtractDetailPage";

//Eauction
import EAUCTION_BUYERAUCTION_LIST from "./Pages/supplier_app/Eauction/BuyerReverseAuctionList";
import EAUCTION_BUYERAUCTIONHISTORY_LIST from "./Pages/supplier_app/Eauction/BuyerAuctionListHistory";
import EAUCTION_LIVE_AUCTION from "./Pages/supplier_app/Eauction/LiveAuction";
import EAUCTION_BUYERAUCTION_CREATE from "./Pages/supplier_app/Eauction/BuyerReverseAuctionCreationE1";
import EAUCTION_BUYERAUCTION_DETAILS from "./Pages/supplier_app/Eauction/BuyerReverseAuctionDetails";
import EAUCTION_LIVE_AUCTION_DETAILS from "./Pages/supplier_app/Eauction/LiveAuctionDetail";
import EAUCTION_SUPPLIER_AUCTION_LIST from "./Pages/supplier_app/Eauction/SupplierAuction/SupplierRevAuctionList";
import EAUCTION_SUPPLIER_AUCTION_DETAILS from "./Pages/supplier_app/Eauction/SupplierAuction/SupplierRevAuctionDetails";
import EAUCTION_SUPPLIER_LIVE_AUCTION_DETAILS from "./Pages/supplier_app/Eauction/SupplierAuction/SupplierLiveReverseAuctionDetail";
// Supplier_App END -----------------------------------------------------------------------------------------------------------------

// Customer_App START -----------------------------------------------------------------------------------------------------------------

// import CUSTOMER_HOME from './Pages/customer_app';
import CUSTOMER_HOME_INTRO from "./Pages/customer_app/HomeIntro/HomeIntro";
import CUSTOMER_DASHBOARD from "./Pages/customer_app/Dashboard";
import CUSTOMER_INBOX from "./Pages/customer_app/Inbox";
import CUSTOMER_OUTBOX from "./Pages/customer_app/Outbox";

// CUSTOMER
// import CUSTOMER_SELF_REGISTRATION from './Pages/customer_app/Customer/CustomerMaster/CustomerList';
import CUSTOMER_REGISTRATION from "./Pages/customer_app/Customer/CustomerMaster/CustomerMasterCreate";
import CUSTOMER_LIST from "./Pages/customer_app/Customer/CustomerMaster/CustomerList";
import CUSTOMER_MASS_UPLOAD from "./Pages/customer_app/Customer/CustomerMaster/CustomerList";
import CUSTOMER_MASTER_CREATE from "./Pages/customer_app/Customer/CustomerMaster/CustomerMasterCreate";
import CUSTOMER_DETAILED_PAGE_CREATE from "./Pages/customer_app/Customer/CustomerMaster/CustomerDetailedPage";
import CUSTOMER_DETAILED_PAGE_WORKFLOW from "./Pages/customer_app/Customer/CustomerMaster/CustomerDetailedPageWorkflow";

//CUSTOMER V1
import CUSTOMER_V1_REGISTER from "./Pages/customer_app/Customer_V1/CustMaster/CustomerRegistrationV1";
import CUSTOMER_V1_REGISTER_LOGIN from "./Pages/customer_app/Customer_V1/CustMaster/CustomerRegistrationV1Login";

//CUSTOMER_V1_REGISTER_DETAIL
import CUSTOMER_V1_REGISTER_DETAIL from "./Pages/customer_app/Customer_V1/CustMaster/CustomerRegistrationV1Details";

// PRESALES
import PRESALES_INQUIRY_CREATION from "./Pages/customer_app/Customer/PreSales/CreateInquiry";
import PRESALES_INQUIRY_LIST from "./Pages/customer_app/Customer/PreSales/InquiryList";
import PRESALES_INQUIRY_DETAILS from "./Pages/customer_app/Customer/PreSales/InquiryDetailPage";
import PRESALES_CUSTOMER_CREATE_QUOTATION from "./Pages/customer_app/Customer/PreSales/CreateQuotation";
import PRESALES_CUSTOMER_QUOTATION_DETAILS from "./Pages/customer_app/Customer/PreSales/QuotationDetailPage";
import PRESALES_CUSTOMER_QUOTATION_LIST from "./Pages/customer_app/Customer/PreSales/QuotationList";
import PRESALES_CUSTOMER_QUOTATION_CREATE_PO from "./Pages/customer_app/Customer/PreSales/CreatePOQuotation";
import INQUIRY_COSTING_SHEET_CREATION from "./Pages/customer_app/Customer/PreSales/CreateInqCostingSheet";

// SALES
import SALES_PURCHASE_ORDER_LIST from "./Pages/customer_app/Customer/Sales/CustPurchaseOrderList";
import SALES_SALES_ORDER_LIST from "./Pages/customer_app/Customer/Sales/SalesOrderList";
import SALES_SALES_ORDER_CREATION from "./Pages/customer_app/Customer/Sales/CreateSO";
import SALES_PURCHASE_ORDER_DETAILS from "./Pages/customer_app/Customer/Sales/CustPurchaseOrderDetails";
import SALES_SALES_ORDER_DETAILS from "./Pages/customer_app/Customer/Sales/SalesOrderDetails";
import SALES_DELIVERY_CREATION from "./Pages/customer_app/Customer/Sales/CreateDelivery";
import SALES_DELIVERY_LIST from "./Pages/customer_app/Customer/Sales/DeliveryList";
import SALES_DELIVERY_DETAILS from "./Pages/customer_app/Customer/Sales/DeliveryDetails";

//work order
import WORK_ORDER_LIST from "./Pages/customer_app/Customer/WorkOrder/WorkOrderList";
import WORK_ORDER_CREATION from "./Pages/customer_app/Customer/WorkOrder/CreateWO";
import WORK_ORDER_DETAILS from "./Pages/customer_app/Customer/WorkOrder/WorkOrderDetails";

// CSTOMER INVOICE
import CUSTOMER_INVOICE_DETAILS from "./Pages/customer_app/Customer/Sales/Invoice/CustInvoiceDetails";
import CUSTOMER_INVOICE_LIST from "./Pages/customer_app/Customer/Sales/Invoice/CustInvoiceList";

// CATALOG
import PRODUCT_CATALOG_LIST from "./Pages/customer_app/ProductCatalog/Catalog";
import PRODUCT_CATALOG_DETAILS from "./Pages/customer_app/ProductCatalog/CatalogDetails";
import PRODUCT_CATALOG_MASTER from "./Pages/customer_app/ProductCatalog/CatalogMaster";
import PRODUCT_CATALOG_SHOPWISE from "./Pages/customer_app/ProductCatalogShopwies/ProductCatalogShopwise";

//BILLING
import CUSTOMER_BILLING from "./Pages/customer_app/Customer/Sales/Billing/Billing";
import CUSTOMER_BILLING_DETAILS from "./Pages/customer_app/Customer/Sales/Billing/BillingDetail";

//BILLING
import CUSTOMER_FEEDBACK from "./Pages/customer_app/Customer/Sales/CustomerFeedback/CustomerFeedback";
import CUSTOMER_FEEDBACK_LIST from "./Pages/customer_app/Customer/Sales/CustomerFeedback/CustomerFeedbackList";

//USER MANUAL
import USER_MANUAL_CUSTOMER_MANUAL from "./Pages/customer_app/Customer/UserManual/CustomerManual";
import USER_MANUAL_MANAGER_MANUAL from "./Pages/customer_app/Customer/UserManual/ManagerManual";

//REPORTS
import CUSTOMER_REPORTS from "./Pages/customer_app/Report/CustomerReports";
import CUSTOMER_REPORT_DETAILS from "./Pages/customer_app/Report/ReportsDetail/CustomerReportsDetails";

//COSTING SHEET
import CUSTOMER_V1_COSTING_SHEET from "./Pages/customer_app/Customer_V1/CostingSheet/CostingSheet";
import CUSTOMER_V1_COSTING_SHEET_LOGIN from "./Pages/customer_app/Customer_V1/CostingSheet/CostingSheetLogin";
import CUSTOMER_V1_COSTING_SHEET_LIST from "./Pages/customer_app/Customer_V1/CostingSheet/CostingSheetList";
import CUSTOMER_V1_COSTING_SHEET_DETAILS from "./Pages/customer_app/Customer_V1/CostingSheet/CostingSheetDetails";

//CUSTOMER QUOTATION
import CUSTOMER_V1_QUOTATION_LIST from "./Pages/customer_app/Customer_V1/Quotation/CustomerQuotationList";
import CUSTOMER_V1_QUOTATION_DETAILS from "./Pages/customer_app/Customer_V1/Quotation/CustomerQuotationDetails";
import CUSTOMER_V1_QUOTATION_CREATION from "./Pages/customer_app/Customer_V1/Quotation/CustomerQuotationCreation";

/* KYC Registration form*/
import CUSTOMER_V1_CUSTOMER_MASTER_LIST from "./Pages/customer_app/Customer_V1/CustMaster/CustomerMasterList";
import CUSTOMER_V1_CUSTOMER_MASTER from "./Pages/customer_app/Customer_V1/CustMaster/CustomerMasterCust";
import CUSTOMER_V1_KYC_REGISTRATION_FORM from "./Pages/customer_app/Customer_V1/KYCForm/KYCRegistrationForm";
import CUSTOMER_V1_REFERENCE_CUSTOMER_DETAILS from "./Pages/customer_app/Customer_V1/KYCForm/ReferenceCustomerDetails";

//SCHEDULING
import CUSTOMER_V1_ORDER_SCHEDULING_LIST from "./Pages/customer_app/Customer_V1/Scheduling/OrderSchedulingList";
import CUSTOMER_V1_ORDER_COMPLETE_SCHEDULING_LIST from "./Pages/customer_app/Customer_V1/Scheduling/OrderCompleteSchedulingList";
import CUSTOMER_V1_ORDER_CANCELLED_SCHEDULING_LIST from "./Pages/customer_app/Customer_V1/Scheduling/OrderCancelledScheduleList";
import CUSTOMER_V1_ORDER_BOOKING_LIST from "./Pages/customer_app/Customer_V1/Scheduling/OrderBookingList ";
import CUSTOMER_V1_PRE_DISPATCH_LIST from "./Pages/customer_app/Customer_V1/Scheduling/PreDispatchList";
import CUSTOMER_V1_POST_DISPATCH_LIST from "./Pages/customer_app/Customer_V1/Scheduling/PostDispatchList";
import CUSTOMER_V1_DISPATCH_CONFIRMATION_LIST from "./Pages/customer_app/Customer_V1/Scheduling/DispatchConfirmationList";
import CUSTOMER_V1_DISPATCHED_CUSTOMER_CONFIRM_LIST from "./Pages/customer_app/Customer_V1/Scheduling/DispatchedCustConfirmList";
import CUSTOMER_V1_IOM_CREDIT_NOTE_LIST from "./Pages/customer_app/Customer_V1/Scheduling/IOMCreditNoteList";

//MATERAIL_MASTER
import CUSTOMER_V1_MATERIAL_MASTER_LIST from "./Pages/customer_app/Customer_V1/MaterialMaster/MaterialList";
import CUSTOMER_V1_MATERIAL_MASTER_CREATION from "./Pages/customer_app/Customer_V1/MaterialMaster/CreateMaterial";
import CUSTOMER_V1_MATERIAL_MASTER_DETAILS from "./Pages/customer_app/Customer_V1/MaterialMaster/MaterialDetails";

//PLANT_MASTER
import CUSTOMER_V1_PLANT_MASTER_LIST from "./Pages/customer_app/Customer_V1/PlantMaster/PlantList";
import CUSTOMER_V1_PLANT_MASTER_CREATION from "./Pages/customer_app/Customer_V1/PlantMaster/CreatePlant";
import CUSTOMER_V1_PLANT_MASTER_DETAILS from "./Pages/customer_app/Customer_V1/PlantMaster/PlantDetails";

//TOLL_MASTER
import CUSTOMER_V1_TOLL_MASTER_LIST from "./Pages/customer_app/Customer_V1/TollMaster/TollList";
import CUSTOMER_V1_TOLL_MASTER_CREATION from "./Pages/customer_app/Customer_V1/TollMaster/CreateToll";
import CUSTOMER_V1_TOLL_MASTER_DETAILS from "./Pages/customer_app/Customer_V1/TollMaster/TollDetails";

//Approval Request form
import CUSTOMER_V1_CREDIT_POLICY_REQUEST_FORM_DETAILS from "./Pages/customer_app/Customer_V1/CreditPolicy/CreditPolicyRequestFormDetails";
import CUSTOMER_V1_CREDIT_POLICY_REQUEST_LIST from "./Pages/customer_app/Customer_V1/CreditPolicy/CreditPolicyRequestList";

//Purchase order
import CUSTOMER_V1_PURCHASE_ORDER_LIST from "./Pages/customer_app/Customer_V1/PurchaseOrder/CustomerPurchaseOrderList";
import CUSTOMER_V1_PURCHASE_ORDER_CREATION from "./Pages/customer_app/Customer_V1/PurchaseOrder/CreatePurchaseOrder";
import CUSTOMER_V1_PURCHASE_ORDER_DETAILS from "./Pages/customer_app/Customer_V1/PurchaseOrder/PurchaseOrderDetails";

//transportation
import CUSTOMER_V1_TRANSPORTAION_CREATION from "./Pages/customer_app/Customer_V1/Transportation/CreateTransportation";
import CUSTOMER_V1_TRANSPORTAION_LIST from "./Pages/customer_app/Customer_V1/Transportation/TransportationList";

//Tender
import CREATE_TENDER from "./Pages/supplier_app/Tender/CreateTender";
import TENDER_LIST from "./Pages/supplier_app/Tender/TenderList";
import TENEDER_DETAILS from "./Pages/supplier_app/Tender/TenderDetails";
import TND_QTN_LIST from "./Pages/supplier_app/Tender/TndQuotationList";
import TND_QTN_DETAILS from "./Pages/supplier_app/Tender/TndQtnDetails";
import TND_RFQ_LIST from "./Pages/supplier_app/Tender/TenderRfqList";
import TND_RFQ_DETAIL from "./Pages/supplier_app/Tender/TenderRFQDetails";
import TND_COMMERCIAL_EVAL from "./Pages/supplier_app/Tender/CommEvaluation/TndCommercialEvaluation";
import TND_COMMERCIAL_EVAL_DETAILS from "./Pages/supplier_app/Tender/CommEvaluation/TndCommercialEvaluationDetails";
import TND_PURCHASE_ORDER_CREATION from "./Pages/supplier_app/Tender/Purchase/PurchaseOrderCreation";
import TND_PURCHASE_ORDER_CREATION_P2 from "./Pages/supplier_app/Tender/Purchase/TenderPOCreation";
import SHOW_WISE_CATALOG from "./Pages/supplier_app/ShopWiseCatalog/ShopByCategories";

import PUBLIC_QTN_CREATION from "./Pages/supplier_app/Tender/CreateQuotation";
import PUBLIC_QTN_VERSION_CREATION from "./Pages/supplier_app/Tender/CreateQuotation";

import PLANT_MASTER_LIST from "./Pages/supplier_app/Master/PlantMaster/PlantMasterList";
import PLANT_MASTER_DETAILS from "./Pages/supplier_app/Master/PlantMaster/PlantMasterList";

import PURCHASE_GROUP_LIST from "./Pages/supplier_app/Master/PurchaseOrgMaster/PurchaseGroupList";
import PURCHASE_GROUP_DETAILS from "./Pages/supplier_app/Master/PurchaseOrgMaster/PurchaseGroupList";
import PARTNERS_360_PAGE from "./Pages/supplier_app/Supplier/SupplierMaster/Partners360Details";

// CUSTOMER V2 ==============================================

//CUSTOMER V2 registration
import CUSTOMER_V2_REGISTER from "./Pages/customer_app/Customer_V2/CustMaster/CustomerRegistrationV2";
import CUSTOMER_V2_REGISTER_LOGIN from "./Pages/customer_app/Customer_V2/CustMaster/CustomerRegistrationLoginV2";

//CUSTOMER LIST
import CUSTOMER_V2_CUSTOMER_MASTER_LIST from "./Pages/customer_app/Customer_V2/CustMaster/CustomerMasterListV2";
import CUSTOMER_V2_CUSTOMER_MASTER from "./Pages/customer_app/Customer_V2/CustMaster/CustomerMasterCustV2";

//CUSTOMER_V1_REGISTER_DETAIL
import CUSTOMER_V2_REGISTER_DETAIL from "./Pages/customer_app/Customer_V2/CustMaster/CustomerRegistrationDetailsV2";

//Scheduling
import CUSTOMER_V2_ORDER_BOOKING_LIST from "./Pages/customer_app/Customer_V2/Scheduling/OrderBookingListV2";

import CUSTOMER_V2_ORDER_BOOKING_LIST_LINE_ITEM from "./Pages/customer_app/Customer_V2/Scheduling/OrderBookingList ";

import CUSTOMER_V2_ORDER_SCHEDULING_LIST from "./Pages/customer_app/Customer_V2/Scheduling/OrderSchedulingList";
import CUSTOMER_V2_PRE_DISPATCH_LIST from "./Pages/customer_app/Customer_V2/Scheduling/PreDispatchList";
import CUSTOMER_V2_POST_DISPATCH_LIST from "./Pages/customer_app/Customer_V2/Scheduling/PostDispatchList";
import CUSTOMER_V2_LOADING_ADVICE_LIST from "./Pages/customer_app/Customer_V2/Scheduling/LoadingAdviceList";
import CUSTOMER_V2_LOADING_ADVICE_DETAIL from "./Pages/customer_app/Customer_V2/Scheduling/LoadingAdviceDetails";

//cash_request
import CUSTOMER_V2_CASH_REQUEST_LIST from "./Pages/customer_app/Customer_V2/CashRequest/CashRequestList";
import CUSTOMER_V2_CASH_REQUEST_UPDATE from "./Pages/customer_app/Customer_V2/CashRequest/CashRequestUpdate";

//invoice
import CUSTOMER_V2_INVOICE_DETAILS from "./Pages/customer_app/Customer_V2/Invoice/CustInvoiceDetailsV2";
import CUSTOMER_V2_INVOICE_LIST from "./Pages/customer_app/Customer_V2/Invoice/CustInvoiceListV2";
import CUSTOMER_V2_MANUAL_INVOICE_CREATION from "./Pages/customer_app/Customer_V2/ManualInvoice/ManualInvoiceCreate";

//dashboard
import CUSTOMER_V2_DASHBOARD from "./Pages/customer_app/Customer_V2/Dashboard/CustomerV2Dashboard";

//RFQ
import CUSTOMER_V2_RFQ_CREATION from "./Pages/customer_app/Customer_V2/RFQ/CreateRFQV2";
import CUSTOMER_V2_RFQ_CREATION_MANUAL from "./Pages/customer_app/Customer_V2/RFQ/CreateRFQManualV2";
import CUSTOMER_V2_RFQ_LIST from "./Pages/customer_app/Customer_V2/RFQ/RequestForQuotationListV2";
import CUSTOMER_V2_RFQ_DETAIL from "./Pages/customer_app/Customer_V2/RFQ/RFQDetailsV2";
import CUSTOMER_V2_RFQ_COMMERCIAL_EVALUATION from "./Pages/customer_app/Customer_V2/RFQ/CommercialEvaluation";

//indent
import CUSTOMER_V2_INDENT_CREATION from "./Pages/customer_app/Customer_V2/Construction/CreateIndentV2";
import CUSTOMER_V2_INDENT_LIST from "./Pages/customer_app/Customer_V2/Construction/IndentListV2";
import CUSTOMER_V2_INDENT_DETAILS from "./Pages/customer_app/Customer_V2/Construction/IndentDetailPageV2";

//vendor

import CUSTOMER_V2_VENDOR_RFQ_LIST from "./Pages/customer_app/Customer_V2/Construction/VendorRequestForQuotationListV2";
import CUSTOMER_V2_VENDOR_RFQ_DETAIL from "./Pages/customer_app/Customer_V2/Construction/VendorRFQDetailsV2";

import CUSTOMER_V2_VENDOR_QUOTATION_LIST from "./Pages/customer_app/Customer_V2/Construction/VendorQuotationListV2";

//Purchase Order
import CUSTOMER_V2_PURCHASE_ORDER_CREATION from "./Pages/customer_app/Customer_V2/PurchaseOrder/CreatePurchaseOrderV2";
import CUSTOMER_V2_PURCHASE_ORDER_LIST from "./Pages/customer_app/Customer_V2/PurchaseOrder/CustomerPurchaseOrderListV2";
import CUSTOMER_V2_PURCHASE_ORDER_DETAILS from "./Pages/customer_app/Customer_V2/PurchaseOrder/PurchaseOrderDetailsV2";

// quotation
import CUSTOMER_V2_QUOTATION_LIST from "./Pages/customer_app/Customer_V2/Construction/QuotationListV2";
import CUSTOMER_V2_QUOTATION_CREATION from "./Pages/customer_app/Customer_V2/Construction/CreateQuotationV2";
import CUSTOMER_V2_QUOTATION_DETAILS from "./Pages/customer_app/Customer_V2/Construction/QuotationDetailPageV2";

//Bulck Upload
import CUSTOMER_V2_ORDER_BULCK_UPLOAD from "./Pages/customer_app/Customer_V2/bulck_upload/OrderBulckUpload";

import CUSTOMER_V2_CREDIT_POLICY_REQUEST_FORM_DETAILS from "./Pages/customer_app/Customer_V2/CreditPolicy/CreditPolicyRequestFormDetails";
import CUSTOMER_V2_CREDIT_POLICY_REQUEST_LIST from "./Pages/customer_app/Customer_V2/CreditPolicy/CreditPolicyRequestList";

// Purchase
import CUSTOMER_V2_PURCHASE_LIST from "./Pages/customer_app/Customer_V2/Purchase/PurchaseList";
import CUSTOMER_V2_PURCHASE_CREATION from "./Pages/customer_app/Customer_V2/Purchase/CreatePurchase";
import CUSTOMER_V2_PURCHASE_DETAILS from "./Pages/customer_app/Customer_V2/Purchase/PurchaseDetails";

//LEDGERS
import CUSTOMER_LEDGERS from "./Pages/customer_app/Ledgers/CustomerLedgers";
import CUSTOMER_LEDGERS_DETAILS from "./Pages/customer_app/Ledgers/LedgersDetail/CustomerLedgersDetails";

//custom reports
import CUSTOMER_V2_CUSTOM_REPORTS from "./Pages/customer_app/Customer_V2/CustomReport/CustomReportV2";

import CUSTOMER_V2_DAILY_EXPENSES from "./Pages/customer_app/Customer_V2/Cash_Expeneses/CashExpensesList";
import CUSTOMER_V2_BANK_STATEMENT from "./Pages/customer_app/Customer_V2/bulck_upload/BankStatementList";

// CUSTOMER V3 ==============================================

// customer-v3
import CUSTOMER_V3_CUSTOMER_SELF_REGISTER from "./Pages/customer_app/Customer_V3/CustomerSelfRegistrationV3";
import CUSTOMER_V4_CUSTOMER_SELF_REGISTER from "./Pages/customer_app/Customer_V3/CustomerSelfRegistrationV4";
import CUSTOMER_V3_CUSTOMER_REGISTRATION from "./Pages/customer_app/Customer_V3/CustomerRegistration";
import CUSTOMER_V3_CUSTOMER_DETAILS from "./Pages/customer_app/Customer_V3/CustomerDetailedPage";
import CUSTOMER_V4_CUSTOMER_DETAILS from "./Pages/customer_app/Customer_V3/CustomerDetailedPageV4";
import CUSTOMER_V3_CUSTOMER_WORKFLOW_DETAILS from "./Pages/customer_app/Customer_V3/CustomerDetailedPageWorkflow";
import CUSTOMER_V4_CUSTOMER_WORKFLOW_DETAILS from "./Pages/customer_app/Customer_V3/CustomerDetailedPageV4Workflow";
import CUSTOMER_V3_CUSTOMER_LIST from "./Pages/customer_app/Customer_V3/CustomerListV3";

// CUSTOMER V4 ==============================================

import CUSTOMER_V4_MATERIAL_PRICE_BREAKDOWN from "./Pages/customer_app/Customer_V4/MaterialPriceBreakDown/MaterilPriceBreakDownCreation";
import CUSTOMER_V4_MATERIAL_PRICE_BREAKDOWN_DETAILS from "./Pages/customer_app/Customer_V4/MaterialPriceBreakDown/MaterilPriceBreakDownDetail";

import CUSTOMER_V4_CUSTOMER_SALES_BREAKDOWN from "./Pages/customer_app/Customer_V4/Sales/CustomerSalesBreakDown";
import CUSTOMER_V4_CUSTOMER_SALES_BREAKDOWN_DETAILS from "./Pages/customer_app/Customer_V4/Sales/CustomerSalesBreakDownDetails";

import CUSTOMER_V4_QUOTATION_ESTIMATE from "./Pages/customer_app/Customer_V4/Quotation/QuotationEstimate";
import CUSTOMER_V4_QUOTATION_ESTIMATE_DETAILS from "./Pages/customer_app/Customer_V4/Quotation/QuotationEstimateDetails";

import CUSTOMER_V4_FINANCE_PRICE_BREAKDOWN_CREATION from "./Pages/customer_app/Customer_V4/FinancePriceBreakDown/FinancePriceBreakDownCreation";

// CUSTOMER V5 ==============================================

import EQUIPMENT_MASTER_LIST from "./Pages/customer_app/Customer_V5/Equipment/EquipmentList";
import CUSTOMERV5_RENTREQUEST_LIST from "./Pages/customer_app/Customer_V5/RequestForRent/RequestForRentList";
import CUSTOMERV5_RENTREQUEST_DETAILS from "./Pages/customer_app/Customer_V5/RequestForRent/RequestForRentDetails";
import CUSTOMERV5_RENTREQUEST_MASTER from "./Pages/customer_app/Customer_V5/RequestForRent/RentRequestMaster";
import CUST_GATE_ENTRY_LIST from "./Pages/customer_app/Customer_V5/GateEntry/GateEntryInWordOutWardList";
import CUST_GATE_ENTRY_UPDATE from "./Pages/customer_app/Customer_V5/GateEntry/GateEntryUpdate";
import CUST_GATE_ENTRY_CREATION from "./Pages/customer_app/Customer_V5/GateEntry/CreateGateEntry";
import CUST_QUALITY_INSPECTION_LIST from "./Pages/customer_app/Customer_V5/QualityInspection/CustQualityInspectionList";
import CUST_QUALITY_INPSECTION_CREATION from "./Pages/customer_app/Customer_V5/QualityInspection/CustQualityInspectionCreation";
import CUST_QUALITY_INPSECTION_DETAILS from "./Pages/customer_app/Customer_V5/QualityInspection/CustQualityInspectionDetails";
import WO_DELIVERY_CREATION from "./Pages/customer_app/Customer_V5/QualityInspection/WoCreateDelivery";
import WO_DELIVERY_LIST from "./Pages/customer_app/Customer_V5/QualityInspection/WoDeliveryList";
import WO_DELIVERY_DETAILS from "./Pages/customer_app/Customer_V5/QualityInspection/WoDeliveryDetails";

// Customer_App END  -----------------------------------------------------------------------------------------------------------------

// LogisticsConstants start ---------------------------------------------------------------------------------------------------------

import LOGISTICS_HOME_INTRO from "./Pages/logistics_app/HomeIntro/HomeIntro";
import LOGISTICS_DASHBOARD from "./Pages/logistics_app/Dashboard";

import LOGISTICS_MASTER_VEHICLE_CREATE from "./Pages/logistics_app/Logistics_V1/Master/Vehicle/CreateVehicle";
import LOGISTICS_MASTER_VEHICLE_DETAILS from "./Pages/logistics_app/Logistics_V1/Master/Vehicle/VehicleDetails";
import LOGISTICS_MASTER_VEHICLE_LIST from "./Pages/logistics_app/Logistics_V1/Master/Vehicle/VehicleList";

// DRIVER
import LOGISTICS_MASTER_DRIVER_CREATE from "./Pages/logistics_app/Logistics_V1/Master/Driver/CreateDriver";
import LOGISTICS_MASTER_DRIVER_DETAILS from "./Pages/logistics_app/Logistics_V1/Master/Driver/DriverDetails";
import LOGISTICS_MASTER_DRIVER_LIST from "./Pages/logistics_app/Logistics_V1/Master/Driver/DriverList";

//Transporter
import LOGISTICS_TRANSPORT_REQUEST_CREATE from "./Pages/logistics_app/Logistics_V1/Transport/CreateTransportRequest";
import LOGISTICS_TRANSPORT_REQUEST_LIST from "./Pages/logistics_app/Logistics_V1/Transport/TransportRequestList";
import LOGISTICS_TRANSPORT_REQUEST_DETAILS from "./Pages/logistics_app/Logistics_V1/Transport/TransportRequestDetails";

// Master/Transporter
import LOGISTICS_MASTER_TRANSPORTER_REGISTRATION from "./Pages/logistics_app/Logistics_V1/Master/Transporter/TransporterRegistration";
import LOGISTICS_MASTER_TRANSPORTER_LIST from "./Pages/logistics_app/Logistics_V1/Master/Transporter/TransporterMasterList";
import LOGISTICS_MASTER_TRANSPORTER_DETAILS from "./Pages/logistics_app/Logistics_V1/Master/Transporter/TransporterRegistrationDetails";

// //Gate Entry
import LOGISTICS_IN_WORD_OUT_WORD_LIST from "./Pages/logistics_app/Logistics_V1/GateEntry/GateEntryInWordOutWardList";
import LOGISTICS_GATE_ENTRY_UPDATE from "./Pages/logistics_app/Logistics_V1/GateEntry/GateEntryUpdate";

//fuel entry
import LOGISTICS_FUEL_ENTRY_LIST from "./Pages/logistics_app/Logistics_V1/FuelEntry/FuelEntryList";

// Bunk
import LOGISTICS_MASTER_BUNK_CREATE from "./Pages/logistics_app/Logistics_V1/Master/Bunk/CreateBunk";
import LOGISTICS_MASTER_BUNK_DETAILS from "./Pages/logistics_app/Logistics_V1/Master/Bunk/BunkDetails";
import LOGISTICS_MASTER_BUNK_LIST from "./Pages/logistics_app/Logistics_V1/Master/Bunk/BunkList";

// Bank
import LOGISTICS_BANK_LIST from "./Pages/logistics_app/Logistics_V1/Master/Bank/BankList";
// LogisticsConstants End ---------------------------------------------------------------------------------------------------------

// InventoryConstants start ---------------------------------------------------------------------------------------------------------
import HR_HOME_INTRO from "./Pages/hr_app/HomeIntro/HomeIntro";
import HR_DASHBOARD from "./Pages/hr_app/Dashboard";

//Stock
import WH_STOCK_LIST from "./Pages/warehouse_app/StockMaster/StockList";
import WH_STOCK_CREATION from "./Pages/warehouse_app/StockMaster/CreateStock";
import WH_STOCK_DETAILS from "./Pages/warehouse_app/StockMaster/StockDetails";

//ware-house
import WH_WAREHOUSE_LIST from "./Pages/warehouse_app/WareHouseMaster/WareHouse/WareHouseList";
import WH_WAREHOUSE_CREATION from "./Pages/warehouse_app/WareHouseMaster/WareHouse/CreateWareHouse";
import WH_WAREHOUSE_DETAILS from "./Pages/warehouse_app/WareHouseMaster/WareHouse/WareHouseDetails";

//Order Creation
import WH_ORDER_CREATION from "./Pages/warehouse_app/WareHouseMaster/OrderCreation/CreateOrder";
import WH_ORDER_DETAILS from "./Pages/warehouse_app/WareHouseMaster/OrderCreation/OrderDetails";
import WH_ORDER_LIST from "./Pages/warehouse_app/WareHouseMaster/OrderCreation/OrderList";

// InventoryConstants End ---------------------------------------------------------------------------------------------------------

// PLM start ---------------------------------------------------------------------------------------------------------
import PLM_HOME_INTRO from "./Pages/plm_app/HomeIntro/HomeIntro";
import PLM_DASHBOARD from "./Pages/plm_app/Dashboard";

// Product Articles
import PRODUCT_ARTICLES_ARTICLE_CREATION from "./Pages/plm_app/ProductArticles/ArticleCreation";
import PRODUCT_ARTICLES_ARTICLE_DETAILS from "./Pages/plm_app/ProductArticles/ArticleDetails";
import PRODUCT_ARTICLES_ARTICLE_LIST from "./Pages/plm_app/ProductArticles/ArticleList";
import PRODUCT_ARTICLES_ARTICLE from "./Pages/plm_app/ProductArticles/ProductArticle";
import PRODUCT_ARTICLE_MASTER_BULK_UPLOAD from "./Pages/plm_app/ProductMatrix/Article_Master_Bulk_Upload/ArticleMasterBulkUpload";

// product Matrix
import PRODUCT_MATRIX_PRODUCTMATRIX_DETAILS from "./Pages/plm_app/ProductMatrix/ProductMatrixDetails1";
import PRODUCT_MATRIX_PRODUCTMATRIX_CREATION from "./Pages/plm_app/ProductMatrix/ProductMatrixCreation";
import PRODUCT_MATRIX_PRODUCTMATRIX_LIST from "./Pages/plm_app/ProductMatrix/ProductMatrixList";
import PRODUCT_MATRIX_PRODUCTMATRIX_CREATIONP2 from "./Pages/plm_app/ProductMatrix/ProductMatrixCreationP2";

// PLM End ---------------------------------------------------------------------------------------------------------

// PDM start ---------------------------------------------------------------------------------------------------------
import PDM_HOME_INTRO from "./Pages/pdm_app/HomeIntro/HomeIntro";
import PDM_INBOX from "./Pages/pdm_app/Inbox";
import PDM_OUTBOX from "./Pages/pdm_app/Outbox";
import PDM_DASHBOARD from "./Pages/pdm_app/Dashboard";

// PDM End ---------------------------------------------------------------------------------------------------------

// AP_AUTO start ---------------------------------------------------------------------------------------------------------
import AP_AUTO_HOME_INTRO from "./Pages/ap_auto_app/HomeIntro/HomeIntro";
import AP_AUTO_INBOX from "./Pages/ap_auto_app/Inbox";
import AP_AUTO_OUTBOX from "./Pages/ap_auto_app/Outbox";
import AP_AUTO_DASHBOARD from "./Pages/ap_auto_app/Dashboard";

import AP_SUPPLIER_LIST from "./Pages/ap_auto_app/Paybles/Vendors/ApSupplierList";
import AR_CUSTOMER_LIST from "./Pages/ap_auto_app/Receivables/Customer/ARCustomerList";
import AP_INVOICE_LIST from "./Pages/ap_auto_app/Paybles/Invoice/ApInvoiceList";
import AR_INVOICE_LIST from "./Pages/ap_auto_app/Receivables/Invoice/ArInvoiceList";
import AP_PURCHASE_ORDER from "./Pages/ap_auto_app/Paybles/PurchaseOrder/ApPurchaseOrderList";
import AR_SALES_ORDER from "./Pages/ap_auto_app/Receivables/SalesOrder/ArSalesOrderList";
import AP_INVOICE_AUTO_CREATE from "./Pages/ap_auto_app/Paybles/Invoice/ApInvoiceAutoCreation";
import AR_INVOICE_AUTO_CREATE from "./Pages/ap_auto_app/Receivables/Invoice/ArInvoiceAutoCreation";
import AR_INV_DETAIL from "./Pages/ap_auto_app/Receivables/Invoice/ArInvoiceDetail";
import AP_INV_DETAIL from "./Pages/ap_auto_app/Paybles/Invoice/ApInvoiceDetail";
import BUDGET_CARDS from "./Pages/ap_auto_app/Budget/BudgetCardsShow";
import BUDGET_LIST from "./Pages/ap_auto_app/Budget/BudgetList";
import AP_SUPPLIER_CREATE from "./Pages/ap_auto_app/Paybles/Vendors/SupplierRegAP";
import AR_CUST_CREATE from "./Pages/ap_auto_app/Receivables/Customer/ARCustomerCreate";
import AR_CUST_DETAIL from "./Pages/ap_auto_app/Receivables/Customer/ArCustomerDetailedPage";
import AP_PAYMENT_OUT from "./Pages/ap_auto_app/Paybles/Payment/PaymentOut";
import AR_PAYMENT_IN from "./Pages/ap_auto_app/Receivables/Payment/PaymentIn";
import AP_WORK_FLOW from "./Pages/ap_auto_app/Paybles/Workflow/WorkFlowApprove";
import AP_CREATE_PO from "./Pages/ap_auto_app/Paybles/PurchaseOrder/ApCreatePO";
import AP_PO_DETAILS from "./Pages/ap_auto_app/Paybles/PurchaseOrder/ApPODetails";
import AR_CREATE_SO from "./Pages/ap_auto_app/Receivables/SalesOrder/ArCreateSO";
import AP_EXP_INV_CREATE from "./Pages/ap_auto_app/Expense/ApExpInvCreation";
import AP_EXP_INV_LIST from "./Pages/ap_auto_app/Expense/ApExpInvList";
import AP_EXP_INV_DETAILS from "./Pages/ap_auto_app/Expense/ApExpInvDetails";
import AP_EXP_PAY_OUT from "./Pages/ap_auto_app/Expense/Payment/ExpPaymentOut";
import AP_AUTO_REPORTS from "./Pages/ap_auto_app/Report/ApAutoReports";
import AP_AUTO_REPORTS_DETAIL from "./Pages/ap_auto_app/Report/ReportsDetail/ApAutoReportsDetails";

// AP_AUTO End ---------------------------------------------------------------------------------------------------------

import VIEWNOTIFI from "./Components/Notification/ViewAllNotifications";

//V1 Start------------------------------------------------------------
import MATERIAL_CATLOG_SHOWPWISE_V1 from "./Pages/supplier_app/MaterialCatalogShopwies/MaterialCatalogShopwiseV1";
import PUBLIC_TENDOR_LIST from "./Pages/supplier_app/Tender/PublicTenderList";
import PUBLIC_TND_DETAILS from "./Pages/supplier_app/Tender/PublicTenderDetails";

import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
import { initializeAppData } from "./AppDataUtils";

// Redux
import {
  addAppInfo,
  appConfigFunc,
  updateAppCode,
} from "./redux/feature/appSlice";
import usePageTracking from "./usePageTracking";

//Assest_app-----------------------------------------------------------------------------------------------------------------
import ASSTE_HOME_INTRO from "./Pages/asset_app/HomeIntro/HomeIntro";
import ASSETConstants from "./common/ASSETConstants";
import ASSET_INBOX from "./Pages/asset_app/Inbox";
import ASSET_OUTBOX from "./Pages/asset_app/Outbox";
import ASSET_DASHBOARD from "./Pages/asset_app/Dashboard";

//---------------------------------------------------------------------------------------------------------------------------

//Warehouse_app-----------------------------------------------------------------------------------------------------------------
import WAREHOUSE_HOME_INTRO from "./Pages/warehouse_app/HomeIntro/HomeIntro";
import WAREHOUSE_INBOX from "./Pages/warehouse_app/Inbox";
import WAREHOUSE_OUTBOX from "./Pages/warehouse_app/Outbox";
import WAREHOUSE_DASHBOARD from "./Pages/warehouse_app/Dashboard";
import WarehouseConstants from "./common/WarehouseConstants";

import WAREHOUSE_MATERIAL_LIST from "./Pages/warehouse_app/Material/MaterialWH";
import WH_MAT_INDENT_CREATION from "./Pages/warehouse_app/Indent/CreateIndentWH";
import WH_MAT_INDENT_LIST from "./Pages/warehouse_app/Indent/IndentListWH";
import WH_MAT_INDENT_DETAILS from "./Pages/warehouse_app/Indent/IndentDetailPageWH";
import WH_CREATE_PO from "./Pages/warehouse_app/PO/CreatePOWH";
import WH_PO_LIST from "./Pages/warehouse_app/PO/PurchaseOrderListWH";
import WH_PO_DETAILS from "./Pages/warehouse_app/PO/PurchaseOrderDetailPageWH";

//---------------------------------------------------------------------------------------------------------------------------
//Factory_app-----------------------------------------------------------------------------------------------------------------
import FACTORY_MNG_HOME_INTRO from "./Pages/factory_management_app/HomeIntro/HomeIntro";
import FACTORY_MNG_INBOX from "./Pages/factory_management_app/Inbox";
import FACTORY_MNG_OUTBOX from "./Pages/factory_management_app/Outbox";
import FACTORY_MNG_DASHBOARD from "./Pages/factory_management_app/Dashboard";
import FactoryConstants from "./common/FactoryConstants";

//---------------------------------------------------------------------------------------------------------------------------

//Smart_construnction_app-----------------------------------------------------------------------------------------------------------------
import SC_HOME_INTRO from "./Pages/smart_construction_app/HomeIntro/HomeIntro";
import SC_INBOX from "./Pages/smart_construction_app/Inbox";
import SC_OUTBOX from "./Pages/smart_construction_app/Outbox";
import SC_DASHBOARD from "./Pages/smart_construction_app/Dashboard";
import SCConstants from "./common/SCConstants";
import CONSTRUCTION_ESTIMATE_LIST from "./Pages/smart_construction_app/Customer_V4/Estimate/EstimateList";
import CONSTRUCTION_MATERIAL_PRICE_BREAKDOWN from "./Pages/smart_construction_app/Customer_V4/MaterialPriceBreakDown/MaterilPriceBreakDownCreation";
import CONSTRUCTION_MATERIAL_PRICE_BREAKDOWN_DETAILS from "./Pages/smart_construction_app/Customer_V4/MaterialPriceBreakDown/MaterilPriceBreakDownDetail";
import CONSTRUCTION_CUSTOMER_SALES_BREAKDOWN from "./Pages/smart_construction_app/Customer_V4/Sales/CustomerSalesBreakDown";
import CONSTRUCTION_CUSTOMER_SALES_BREAKDOWN_DETAILS from "./Pages/smart_construction_app/Customer_V4/Sales/CustomerSalesBreakDownDetails";
import CONSTRUCTION_QUOTATION_ESTIMATE from "./Pages/smart_construction_app/Customer_V4/Quotation/QuotationEstimate";
import CONSTRUCTION_QUOTATION_ESTIMATE_DETAILS from "./Pages/smart_construction_app/Customer_V4/Quotation/QuotationEstimateDetails";
import CONSTRUCTION_FINANCE_PRICE_BREAKDOWN_CREATION from "./Pages/smart_construction_app/Customer_V4/FinancePriceBreakDown/FinancePriceBreakDownCreation";
import CONSTRUCTION_CUSTOMER_ESTIMATE_E1 from "./Pages/smart_construction_app/Customer_V4/Estimation/EstimationSpecification";
import CONSTRUCTION_CUSTOMER_ESTIMATE_SPECIFICATION from "./Pages/smart_construction_app/Customer_V4/Estimation/EstimationCreation";
import CONSTRUCTION_CUSTOMER_ESTIMATE_MATERIAL_DETAILS from "./Pages/smart_construction_app/Customer_V4/Estimation/EstimationCreationDetail";
import CONSTRUCTION_QUOTATION_LIST from "./Pages/smart_construction_app/Customer_V4/Quotation_V1/QuotationList";
import CONSTRUCTION_JOB_LIST from "./Pages/smart_construction_app/Customer_V4/Job_HB/JobList";
import CONSTRUCTION_ENTRY_LIST from "./Pages/smart_construction_app/Customer_V4/Entry/EntryList";
import CONSTRUCTION_ESTIMATE_SPECIFICATION_LIST from "./Pages/smart_construction_app/Customer_V4/Estimation/EstimationList";
import CONSTRUCTION_CUSTOMER_ESTIMATE_SPECIFICATION_DETAILS from "./Pages/smart_construction_app/Customer_V4/Estimation/EstimationDetails";
import CONSTRUCTION_CUSTOMER_ESTIMATE_SPECIFICATION_DETAILS_REVISION from "./Pages/smart_construction_app/Customer_V4/Estimation/EstimationDetailsRevision";

import CONSTRUCTION_CUSTOMER_ESTIMATE_SPECIFICATION_WORKFLOW from "./Pages/smart_construction_app/Customer_V4/EstimationWorkFlow/EstimationSpecificationWorkFlow";
import CONSTRUCTION_CUSTOMER_ESTIMATE_CREATION__WORKFLOW from "./Pages/smart_construction_app/Customer_V4/EstimationWorkFlow/EstimationCreationworkFlow";
import CONSTRUCTION_MATERIAL_LIST from "./Pages/smart_construction_app/Customer_V4/Material/Material";
import CONSTRUCTION_CUST_LIST from "./Pages/smart_construction_app/Customer_V4/Customer/ConsCustomerList";
import CONSTRUCTION_CUST_DETAILS from "./Pages/smart_construction_app/Customer_V4/Customer/CustomerDetailedPage";
import CONSTRUCTION_INQ_LIST from "./Pages/smart_construction_app/Customer_V4/Inquiry/InquiryList";
import CONSTRUCTION_INQ_DETAILS from "./Pages/smart_construction_app/Customer_V4/Inquiry/InquiryDetailPage";
import CONSTRUCTION_QNT_LIST from "./Pages/smart_construction_app/Customer_V4/Quotation/QuotationList";
import CONSTRUCTION_QNT_DETAILS from "./Pages/smart_construction_app/Customer_V4/Quotation/QuotationDetails";

//REPORTS
import CONSTRUCTION_REPORTS from "./Pages/smart_construction_app/Report/CustomerReports";
import CONSTRUCTION_REPORT_DETAILS from "./Pages/smart_construction_app/Report/ReportsDetail/CustomerReportsDetails";
//---------------------------------------------------------------------------------------------------------------------------

//AP_Automation_app-----------------------------------------------------------------------------------------------------------------
import APAUTOMATION_HOME_INTRO from "./Pages/ap_automation_app/HomeIntro/HomeIntro";
import APAUTOMATION_INBOX from "./Pages/ap_automation_app/Inbox";
import APAUTOMATION_OUTBOX from "./Pages/ap_automation_app/Outbox";
import APAUTOMATION_DASHBOARD from "./Pages/ap_automation_app/Dashboard";
//---------------------------------------------------------------------------------------------------------------------------

//AP_Automation_app-----------------------------------------------------------------------------------------------------------------
import LEDGER_HOME_INTRO from "./Pages/profit_ledger_app/HomeIntro/HomeIntro";
import LEDGER_INBOX from "./Pages/profit_ledger_app/Inbox";
import LEDGER_OUTBOX from "./Pages/profit_ledger_app/Outbox";
import LEDGER_DASHBOARD from "./Pages/profit_ledger_app/Dashboard";
import LedgerConstants from "./common/LedgerConstants";
import LEDGER_CASH_REQUEST_UPDATE from "./Pages/profit_ledger_app/Profit_ledger/CashRequest/CashRequestUpdate";
import LEDGER_CASH_REQUEST_LIST from "./Pages/profit_ledger_app/Profit_ledger/CashRequest/CashRequestList";
import LEDGER_CASH_REQUEST_CREATE from "./Pages/profit_ledger_app/Profit_ledger/CashRequest/CreateCashRequest";
import LEDGER_BANK_STATEMENT from "./Pages/profit_ledger_app/Profit_ledger/bulck_upload/BankStatementList";
import LEDGER_BANK_STATEMENT_DETAILS from "./Pages/profit_ledger_app/Profit_ledger/bulck_upload/BankStatementDetails";
import LEDGER_DAILY_EXPENSES from "./Pages/profit_ledger_app/Profit_ledger/Cash_Expeneses/CashExpensesList";
import LEDGER_CASH_EXPENSES_DETAILS from "./Pages/profit_ledger_app/Profit_ledger/Cash_Expeneses/CashExpensesDetails";
import LEDGER_CASH_EXPENSES2_DETAILS from "./Pages/profit_ledger_app/Profit_ledger/Cash_Expenes_Upload/CashExpensesDetail";
import LEDGER_CASH_EXPENSES_LIST from "./Pages/profit_ledger_app/Profit_ledger/Cash_Expenes_Upload/CashExpensesList";
import LEDGER_PAYMENT_VOUCHER from "./Pages/profit_ledger_app/Profit_ledger/bulck_upload/PaymentVoucher";
import LEDGER_PAYMENT_RECEIPT from "./Pages/profit_ledger_app/Profit_ledger/bulck_upload/ReceiptVoucher";
//Invoice
import LEDGER_INVOICE_DETAILS from "./Pages/profit_ledger_app/Profit_ledger/Invoice/CustInvoiceDetailsV2";
import LEDGER_MANUAL_INVOICE_DETAILS from "./Pages/profit_ledger_app/Profit_ledger/Invoice/CustInvoiceDetailsV2_Edite";
import LEDGER_INVOICE_LIST from "./Pages/profit_ledger_app/Profit_ledger/Invoice/CustInvoiceListV2";
import LEDGER_MANUAL_INVOICE_CREATION from "./Pages/profit_ledger_app/Profit_ledger/ManualInvoice/ManualInvoiceCreate";
import LEDGER_LOADING_ADVICE_DETAIL from "./Pages/profit_ledger_app/Profit_ledger/Scheduling/LoadingAdviceDetails";
//RFQ
import LEDGER_RFQ_CREATION from "./Pages/profit_ledger_app/Profit_ledger/RFQ/CreateRFQV2";
import LEDGER_RFQ_CREATION_MANUAL from "./Pages/profit_ledger_app/Profit_ledger/RFQ/CreateRFQManualV2";
import LEDGER_RFQ_LIST from "./Pages/profit_ledger_app/Profit_ledger/RFQ/RequestForQuotationListV2";
import LEDGER_RFQ_DETAIL from "./Pages/profit_ledger_app/Profit_ledger/RFQ/RFQDetailsV2";
import LEDGER_RFQ_COMMERCIAL_EVALUATION from "./Pages/profit_ledger_app/Profit_ledger/RFQ/CommercialEvaluation";
//Indent
import LEDGER_INDENT_CREATION from "./Pages/profit_ledger_app/Profit_ledger/Construction/CreateIndentV2";
import LEDGER_INDENT_LIST from "./Pages/profit_ledger_app/Profit_ledger/Construction/IndentListV2";
import LEDGER_INDENT_DETAILS from "./Pages/profit_ledger_app/Profit_ledger/Construction/IndentDetailPageV2";
//purchase order
import LEDGER_PURCHASE_ORDER_CREATION from "./Pages/profit_ledger_app/Profit_ledger/PurchaseOrder/CreatePurchaseOrderV2";
import LEDGER_PURCHASE_ORDER_LIST from "./Pages/profit_ledger_app/Profit_ledger/PurchaseOrder/CustomerPurchaseOrderListV2";
import LEDGER_PURCHASE_ORDER_DETAILS from "./Pages/profit_ledger_app/Profit_ledger/PurchaseOrder/CustomerPurchaseOrderListV2";
import LEDGER_PURCHASE_ORDER_DELIVERY_CONFIRM from "./Pages/profit_ledger_app/Profit_ledger/PurchaseOrder/CustomerDeliveryListV2";
import LEDGER_PURCHASE_ORDER_DELIVERY_DETIALS from "./Pages/profit_ledger_app/Profit_ledger/PurchaseOrder/PurchaseOrderDeliveryDetailsV2";
import LEDGER_PURCHASE_ORDER_PAYMENT_LIST from "./Pages/profit_ledger_app/Profit_ledger/PurchaseOrder/CustomerPaymentListV2";
import LEDGER_COMPANY_REGISTRATION from "./Pages/profit_ledger_app/Profit_ledger/Company/CompanyCrationV2";
import LEDGER_COMPANY_LIST from "./Pages/profit_ledger_app/Profit_ledger/Company/CompnayListV2";
import LEDGER_COMPANY_DETAILS from "./Pages/profit_ledger_app/Profit_ledger/Company/CompanyDetailsV2";
import LEDGER_MATERIAL_LIST from "./Pages/profit_ledger_app/Profit_ledger/Material/MaterialV2";
import LEDGER_PETTY_CASH_LIST from "./Pages/profit_ledger_app/Profit_ledger/PittiCash/PettyCashList";
import LEDGER_PETTY_CASH_CREATE from "./Pages/profit_ledger_app/Profit_ledger/PittiCash/PettyCashCreate";
import LEDGER_SUPPILER_REGISTRATION from "./Pages/profit_ledger_app/Profit_ledger/SupplierMaster/RegistrationPageSV";
import LEDGER_SUPPILER_LIST from "./Pages/profit_ledger_app/Profit_ledger/SupplierMaster/SupplierListSv";
import LEDGER_SUPPILER_MASS_UPLOAD from "./Pages/profit_ledger_app/Profit_ledger/SupplierMaster/SupplierMassUploadSv";
import LEDGER_SUPPLIER_MASTER_CREATE from "./Pages/profit_ledger_app/Profit_ledger/SupplierMaster/SupplierMasterCreateSv";

//ledger logistics
import LEDGER_MASTER_VEHICLE_CREATE from "./Pages/profit_ledger_app/Logistics/Master/Vehicle/PlCreateVehicle";
import LEDGER_MASTER_VEHICLE_LIST from "./Pages/profit_ledger_app/Logistics/Master/Vehicle/PlVehicleList";
import LEDGER_MASTER_VEHICLE_DETAILS from "./Pages/profit_ledger_app/Logistics/Master/Vehicle/PlVehicleDetails";
import LEDGER_MASTER_DRIVER_CREATE from "./Pages/profit_ledger_app/Logistics/Master/Driver/PlCreateDriver";
import LEDGER_MASTER_DRIVER_LIST from "./Pages/profit_ledger_app/Logistics/Master/Driver/PlDriverList";
import LEDGER_MASTER_DRIVER_DETAILS from "./Pages/profit_ledger_app/Logistics/Master/Driver/PlDriverDetails";
import LEDGER_TRANSPORT_REQUEST_CREATE from "./Pages/profit_ledger_app/Logistics/Transport/PlCreateTransportRequest";
import LEDGER_TRANSPORT_REQUEST_LIST from "./Pages/profit_ledger_app/Logistics/Transport/TransportRequestListBK";
import LEDGER_TRANSPORT_REQUEST_DETAILS from "./Pages/profit_ledger_app/Logistics/Transport/PlTransportRequestDetails";
import LEDGER_MASTER_TRANSPORTER_REGISTRATION from "./Pages/profit_ledger_app/Logistics/Master/Transporter/PlTransporterRegistration";
import LEDGER_MASTER_TRANSPORTER_LIST from "./Pages/profit_ledger_app/Logistics/Master/Transporter/PlTransporterMasterList";
import LEDGER_MASTER_TRANSPORTER_DETAILS from "./Pages/profit_ledger_app/Logistics/Master/Transporter/PlTransporterRegistrationDetails";
import LEDGER_IN_WORD_OUT_WORD_LIST from "./Pages/profit_ledger_app/Logistics/GateEntry/PlGateEntryInWordOutWardList";
import LEDGER_GATE_ENTRY_UPDATE from "./Pages/profit_ledger_app/Logistics/GateEntry/PlGateEntryUpdate";
import LEDGER_FUEL_ENTRY_LIST from "./Pages/profit_ledger_app/Logistics/FuelEntry/PlFuelEntryList";
import LEDGER_MASTER_BUNK_CREATE from "./Pages/profit_ledger_app/Logistics/Master/Bunk/PlCreateBunk";
import LEDGER_MASTER_BUNK_LIST from "./Pages/profit_ledger_app/Logistics/Master/Bunk/PlBunkList";
import LEDGER_MASTER_BUNK_DETAILS from "./Pages/profit_ledger_app/Logistics/Master/Bunk/PlBunkDetails";
import LEDGER_BANK_LIST from "./Pages/profit_ledger_app/Logistics/Master/Bank/PlBankList";
import LEDGER_QUOTATION_LIST from "./Pages/profit_ledger_app/Profit_ledger/Construction/QuotationListV2";
import LEDGER_QUOTATION_CREATION from "./Pages/profit_ledger_app/Profit_ledger/Construction/CreateQuotationV2";
import LEDGER_QUOTATION_DETAILS from "./Pages/profit_ledger_app/Profit_ledger/Construction/QuotationDetailPageV2";
import LEDGER_ORDER_BOOKING from "./Pages/profit_ledger_app/Profit_ledger/Scheduling/OrderBookingListV2";
import LEDGER_ORDER_SCHEDULING from "./Pages/profit_ledger_app/Profit_ledger/Scheduling/OrderSchedulingList";
import LEDGER_LOADING_ADVICE from "./Pages/profit_ledger_app/Profit_ledger/Scheduling/LoadingAdviceList";
import LEDGER_CREDIT_POLICY_REQUEST_LIST from "./Pages/profit_ledger_app/Profit_ledger/CreditPolicy/CreditPolicyRequestList";
import LEDGER_CREDIT_POLICY_REQUEST_FORM_DETAILS from "./Pages/profit_ledger_app/Profit_ledger/CreditPolicy/CreditPolicyRequestFormDetails";
import LEDGER_CUSTOM_REPORTS from "./Pages/profit_ledger_app/Profit_ledger/CustomReport/CustomReportV2";
import LEDGER_SALES_OFFICER_CUSTOM_REPORTS from "./Pages/profit_ledger_app/Profit_ledger/CustomReport/SalesOfficerCustomReportV2";
import LEDGER_PURCHASE_LIST from "./Pages/profit_ledger_app/Profit_ledger/Purchase/PurchaseList";
import LEDGER_CUSTOMER_LIST from "./Pages/profit_ledger_app/Profit_ledger/CustMaster/CustomerMasterListV2";
import LEDGER_CUSTOMER_CREATE from "./Pages/profit_ledger_app/Profit_ledger/CustMaster/CustomerRegistrationV2";
import LEDGER_TRANSPORT_REQ_LIST from "./Pages/profit_ledger_app/Logistics/Transport/PlTransportRequestListINT";
import LEDGER_TRANSPORT_REQ_LIST_ACK from "./Pages/profit_ledger_app/Logistics/Transport/PlTransportRequestListACK";
import LEDGER_DELIVERY_PAYMENT_LIST from "./Pages/profit_ledger_app/Logistics/Transport/PlDriverPaymentList";
import LEDGER_FUEL_ENTRY_CREATE from "./Pages/profit_ledger_app/Logistics/FuelEntry/PlFuelEntryCreation";
import LEDGER_EMP_LIST from "./Pages/profit_ledger_app/Profit_ledger/RegistrationPage/EmployeeList";
import LEDGER_EMP_REGISTRATION from "./Pages/profit_ledger_app/Profit_ledger/RegistrationPage/RegistrationPageV2";
import LEDGER_EMP_DETAILS from "./Pages/profit_ledger_app/Profit_ledger/RegistrationPage/EmployeeDetails";
import LEDGER_PURCHASE_CREATION from "./Pages/profit_ledger_app/Profit_ledger/Purchase/CreatePurchase";
import EMAIL_SENDER from "./Pages/EmailSender";
import SENT_EMAIL from "./Pages/SentEmail";
import EMAIL_DETAILS from "./Pages/EmailDetails";
import HRConstants from "./common/HRConstants";
import AccountsConstants from "./common/AccountsConstants";
import { LedgerForm, LedgerList } from "./Pages/accounts/LedgerPages";
import { VoucherForm, VoucherList, VoucherView } from "./Pages/accounts/VoucherPages";
import VoucherEntry from "./Pages/accounts/VoucherEntry";
import { ChequeRegister, PortalPage } from "./Pages/accounts/RegisterPages";
import LedgerStatement from "./Pages/accounts/LedgerStatement";
import CustomersPage from "./Pages/accounts/CustomersPage";
import { SalesOrdersPage, LoadingAdvicesPage, SalesInvoicesPage } from "./Pages/accounts/SalesCyclePages";
import { OutstandingPage, CustomerOutstandingPage, AgingPage, PayablesPage, DayBookPage } from "./Pages/accounts/ReceivableReports";

//-------------------------------------------------------------HR APP-----------------------------------------------------------------/

import HR_EMP_LIST from "./Pages/hr_app/EmpRegistration/EmployeeList";
import HR_EMP_CREATE from "./Pages/hr_app/EmpRegistration/EmpRegistration";
import HR_EMP_DETAILS from "./Pages/hr_app/EmpRegistration/EmployeeDetails";
import ATD_CAL from "./Pages/hr_app/Attendance/AttendanceCal";
import HR_ATD_LIST from "./Pages/hr_app/Attendance/AttendanceList";
import HR_ATD_DETAILS from "./Pages/hr_app/Attendance/AttendanceDetails";
import HR_DOC_LIST from "./Pages/hr_app/HrDocuments/HrDocumentList";
import HR_DOC_CREATE from "./Pages/hr_app/HrDocuments/HrDocumentReg";
import HR_DOC_DETAILS from "./Pages/hr_app/HrDocuments/HrDocumentDetails";
import HR_TASK_LIST from "./Pages/hr_app/TaskManagement/TaskManagementList";
import HR_TASK_DETAILS from "./Pages/hr_app/TaskManagement/TaskDetails";
import HR_TASK_CAL from "./Pages/hr_app/TaskManagement/TaskCal";
import HR_ORG_STRUCTURE from "./Pages/hr_app/OrganizationStructure/OrganizationStructure";
import HR_EXPENSES_LIST from "./Pages/hr_app/Finance/Expeneses/ExpensesList";
import HR_EXPENSES_DETAILS from "./Pages/hr_app/Finance/Expeneses/ExpensesDetails";
import HR_CLIENT_LIST from "./Pages/hr_app/Client/ClientList";
import HR_CLIENT_DETAILS from "./Pages/hr_app/Client/ClientDetails";
import HR_CLIENT_CREATE from "./Pages/hr_app/Client/ClientRegistration";
import HR_PROJECT_LIST from "./Pages/hr_app/Project/HrProjectList";
import HR_PROJECT_CREATE from "./Pages/hr_app/Project/HrProjectReg";
import HR_PROJECT_DETAILS from "./Pages/hr_app/Project/HrProjectDetails";
import HR_RECEIPTS_LIST from "./Pages/hr_app/Finance/Receipts/ReceiptsList";

//--------------------------------------------------------------HR APP END------------------------------------------------------------/

//---------------------------------------------------------------------------------------------------------------------------
// Assume this is your authentication check function
const isAuthenticated = () => {
  const token = localStorage.getItem("token");
  return !!token;
};

const PrivateRoute = ({ children }) => {
  // const location = useLocation();
  // console.log(">> AppRouters >> user isAuthenticated >> " , isAuthenticated());

  // let check = checkHrefLink(menuData, location.pathname);
  // console.log(">> check", check);
  // console.log(">> location.pathname", location.pathname);
  // if(check){
  //     return isAuthenticated() ? children : <Navigate to="/login" />;
  // }else{

  //     return isAuthenticated() ? <Navigate to="/home" /> : <Navigate to="/login" />;
  // }
  usePageTracking();
  return isAuthenticated() ? children : <Navigate to="/login" />;
};

// const checkHrefLink = (arr, url) => {
//     for (let item of arr) {
//         if (item.hrefLink === url) {
//             return true;
//         }
//         if (item.children) {
//             const foundInChildren = checkHrefLink(item.children, url);
//             if (foundInChildren) return true;
//         }
//     }
//     return false;
// };

function AppRouters() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  // const navigate = useNavigate();

  const [getUserData, setUserData] = useState([]);

  useEffect(() => {
    dispatch(appConfigFunc());
    changeLanguage("en"); // kannada, tamil, en, ae
    console.log(">> lang:", t("msg_name"));
    let localData = localStorage.getItem("userData");
    let userData = {};
    if (localData) {
      userData = JSON.parse(localData);
      dispatch(addAppInfo(userData));
      setUserData(userData);
    }

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (getUserData?.data) {
      // console.log(">> App Router >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>", getUserData);
      let appCode = localStorage.getItem("application");
      if (appCode === "SUPPLIER") {
        initializeAppData(dispatch, appCode);
        dispatch(updateAppCode(appCode));
      } else if (appCode === "CUSTOMER") {
        initializeAppData(dispatch, appCode);
        dispatch(updateAppCode(appCode));
      } else if (appCode === "AP_AUTO") {
        initializeAppData(dispatch, appCode);
        dispatch(updateAppCode(appCode));
      } else if (appCode === "LEDGER") {
        initializeAppData(dispatch, appCode);
        dispatch(updateAppCode(appCode));
      } else if (appCode === "WAREHOUSE") {
        initializeAppData(dispatch, appCode);
        dispatch(updateAppCode(appCode));
      } else if (appCode === "HR") {
        initializeAppData(dispatch, appCode);
        dispatch(updateAppCode(appCode));
      } else {
        initializeAppData(dispatch, appCode);
      }
    }

    // eslint-disable-next-line
  }, [dispatch, getUserData]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <>
      {/* <Page404/> */}
      <Routes>
        {/* Public route */}
        <Route exact path="*" element={<Page404 />}></Route>
        <Route exact path="/" element={<Login />}></Route>
        <Route
          exact
          path={SupplierConstantsList.LOGIN}
          element={<Login />}
        ></Route>
        <Route
          exact
          path={SupplierConstantsList.REGISTER}
          element={<Register />}
        ></Route>
        <Route
          exact
          path={SupplierConstantsList.RESET_PASSWORD}
          element={<RESET_PASSWORD />}
        ></Route>
        {/* Private route */}

        <Route
          exact
          path={SupplierConstantsList.COMPANY}
          element={
            <PrivateRoute>
              {" "}
              <Company />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.PROFILE}
          element={
            <PrivateRoute>
              {" "}
              <Profile />{" "}
            </PrivateRoute>
          }
        />

        {/* ----------------------------------  Supplier START  ---------------------------------- */}
        <Route
          exact
          path={SupplierConstantsList.SELF_REGISTRATION}
          element={<SELF_REGISTRATION />}
        />
        <Route
          exact
          path={SupplierConstantsList.SUPPLIER_MASTER_CREATE}
          element={<SUPPLIER_MASTER_CREATE />}
        />
        {/* Common */}
        <Route
          exact
          path={SupplierConstantsList.APP_HOME}
          element={
            <PrivateRoute>
              {" "}
              <AppLandingPage />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.HOME}
          element={
            <PrivateRoute>
              {" "}
              <HOME />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.HOME_INTRO}
          element={
            <PrivateRoute>
              {" "}
              <HOME_INTRO />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.DASHBOARD}
          element={
            <PrivateRoute>
              {" "}
              <DASHBOARD />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.INBOX}
          element={
            <PrivateRoute>
              {" "}
              <INBOX />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.OUTBOX}
          element={
            <PrivateRoute>
              {" "}
              <OUTBOX />{" "}
            </PrivateRoute>
          }
        />
        {/* SUPPILER */}
        <Route
          exact
          path={SupplierConstantsList.SUPPILER_REGISTRATION}
          element={
            <PrivateRoute>
              {" "}
              <SUPPILER_REGISTRATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SUPPILER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <SUPPILER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SUPPILER_MASS_UPLOAD}
          element={
            <PrivateRoute>
              {" "}
              <SUPPILER_MASS_UPLOAD />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SUPPLIER_DETAILED_PAGE_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <SUPPLIER_DETAILED_PAGE_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SUPPLIER_DETAILED_PAGE_WORKFLOW}
          element={
            <PrivateRoute>
              {" "}
              <SUPPLIER_DETAILED_PAGE_WORKFLOW />{" "}
            </PrivateRoute>
          }
        />

        {/* VENDOR */}
        <Route
          exact
          path={SupplierConstantsList.VENDOR_REGISTRATION}
          element={
            <PrivateRoute>
              {" "}
              <VENDOR_REGISTRATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.VENDOR_REGISTRATIONV2}
          element={
            <PrivateRoute>
              {" "}
              <VENDOR_REGISTRATIONV2 />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.VENDOR_SELFREGISTRATIONV1}
          element={
            <PrivateRoute>
              {" "}
              <VENDOR_SELFREGISTRATIONV1 />{" "}
            </PrivateRoute>
          }
        />

        <Route
          exact
          path={SupplierConstantsList.VENDOR_LIST}
          element={
            <PrivateRoute>
              {" "}
              <VENDOR_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.VENDOR_DETAILPAGE_WORKFLOW}
          element={
            <PrivateRoute>
              {" "}
              <VENDOR_DETAILPAGE_WORKFLOW />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.VENDOR_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <VENDOR_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        <Route
          exact
          path={SupplierConstantsList.VENDOR_PREASSESMENT_FORM}
          element={
            <PrivateRoute>
              {" "}
              <VENDOR_PREASSESMENT_FORM />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.VENDOR_PREASSESMENT_FORM_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <VENDOR_PREASSESMENT_FORM_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/* SOURCING */}
        <Route
          exact
          path={SupplierConstantsList.SOURCING_PURCHASE_REQUISITION_LIST}
          element={
            <PrivateRoute>
              {" "}
              <SOURCING_PURCHASE_REQUISITION_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SOURCING_PURCHASE_REQUISITION_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <SOURCING_PURCHASE_REQUISITION_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={
            SupplierConstantsList.SOURCING_PURCHASE_REQUISITION_DETAILED_PAGE
          }
          element={
            <PrivateRoute>
              {" "}
              <SOURCING_PURCHASE_REQUISITION_DETAILED_PAGE />{" "}
            </PrivateRoute>
          }
        />
        {/* SOURCING */}
        <Route
          exact
          path={SupplierConstantsList.SOURCING_VENDOR_REQUEST_FOR_QUOTATION}
          element={
            <PrivateRoute>
              {" "}
              <SOURCING_VENDOR_REQUEST_FOR_QUOTATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SOURCING_VENDOR_QUOTATION_LIST}
          element={
            <PrivateRoute>
              {" "}
              <SOURCING_VENDOR_QUOTATION_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SOURCING_VENDOR_RFQ_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <SOURCING_VENDOR_RFQ_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SOURCING_CREATE_QUOTATION}
          element={
            <PrivateRoute>
              {" "}
              <SOURCING_CREATE_QUOTATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SOURCING_QUOTATION_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <SOURCING_QUOTATION_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SOURCING_BUYER_REQUEST_FOR_QUOTATION}
          element={
            <PrivateRoute>
              {" "}
              <SOURCING_BUYER_REQUEST_FOR_QUOTATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SOURCING_BUYER_QUOTATION_LIST}
          element={
            <PrivateRoute>
              {" "}
              <SOURCING_BUYER_QUOTATION_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SOURCING_BUYER_RFQ_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <SOURCING_BUYER_RFQ_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SOURCING_CREATE_RFQ}
          element={
            <PrivateRoute>
              {" "}
              <SOURCING_CREATE_RFQ />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SOURCING_CREATE_MANUAL_RFQ}
          element={
            <PrivateRoute>
              {" "}
              <SOURCING_CREATE_MANUAL_RFQ />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={
            SupplierConstantsList.SOURCING_TECH_EVALUATION_REQUEST_FOR_QUOTATION
          }
          element={
            <PrivateRoute>
              {" "}
              <SOURCING_TECH_EVALUATION_REQUEST_FOR_QUOTATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SOURCING_TECH_EVALUATION_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <SOURCING_TECH_EVALUATION_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SOURCING_COMMERCIAL_EVALUATION}
          element={
            <PrivateRoute>
              {" "}
              <SOURCING_COMMERCIAL_EVALUATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SOURCING_TECHNICAL_EVALUATION}
          element={
            <PrivateRoute>
              {" "}
              <SOURCING_TECHNICAL_EVALUATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SOURCING_PURCHASE_ORDER_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <SOURCING_PURCHASE_ORDER_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SOURCING_COMMERCIAL_EVALUATION_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <SOURCING_COMMERCIAL_EVALUATION_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/* Purchase  */}
        <Route
          exact
          path={SupplierConstantsList.SOURCING_PURCHASE_CREATE_PO}
          element={
            <PrivateRoute>
              {" "}
              <SOURCING_PURCHASE_CREATE_PO />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SOURCING_PURCHASE_ORDER_CREATION2}
          element={
            <PrivateRoute>
              {" "}
              <SOURCING_PURCHASE_ORDER_CREATION2 />{" "}
            </PrivateRoute>
          }
        />

        <Route
          exact
          path={SupplierConstantsList.SOURCING_PURCHASE_REQUISITION_CREATIONPR}
          element={
            <PrivateRoute>
              {" "}
              <SOURCING_PURCHASE_REQUISITION_CREATIONPR />{" "}
            </PrivateRoute>
          }
        />

        {/* POCOLLABRATION */}
        <Route
          exact
          path={
            SupplierConstantsList.POCOLLABRATION_SERVICE_PURCHASE_ORDER_LIST
          }
          element={
            <PrivateRoute>
              {" "}
              <POCOLLABRATION_SERVICE_PURCHASE_ORDER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.POCOLLABRATION_PURCHASE_ORDER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <POCOLLABRATION_PURCHASE_ORDER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.POCOLLABRATION_PURCHASE_ORDER_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <POCOLLABRATION_PURCHASE_ORDER_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.POCOLLABRATION_GOODS_RECEIVED_NOTE}
          element={
            <PrivateRoute>
              {" "}
              <POCOLLABRATION_GOODS_RECEIVED_NOTE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.POCOLLABRATION_SERVICE_ENTRY_SHEET}
          element={
            <PrivateRoute>
              {" "}
              <POCOLLABRATION_SERVICE_ENTRY_SHEET />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.POCOLLABRATION_INVOICE}
          element={
            <PrivateRoute>
              {" "}
              <POCOLLABRATION_INVOICE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.POCOLLABRATION_INVOICE_DETIAILS}
          element={
            <PrivateRoute>
              {" "}
              <POCOLLABRATION_INVOICE_DETIAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.POCOLLABRATION_PAYMENT_LIST}
          element={
            <PrivateRoute>
              {" "}
              <POCOLLABRATION_PAYMENT_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.POCOLLABRATION_PURCHASE_ORDER_DETAIL_PAGE}
          element={
            <PrivateRoute>
              {" "}
              <POCOLLABRATION_PURCHASE_ORDER_DETAIL_PAGE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.POCOLLABRATION_ASN}
          element={
            <PrivateRoute>
              {" "}
              <POCOLLABRATION_ASN />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.POCOLLABRATION_ASN_DETAIL_PAGE}
          element={
            <PrivateRoute>
              {" "}
              <POCOLLABRATION_ASN_DETAIL_PAGE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.POCOLLABRATION_ASN_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <POCOLLABRATION_ASN_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.POCOLLABRATION_SA_ASN_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <POCOLLABRATION_SA_ASN_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.POCOLLABRATION_GRN_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <POCOLLABRATION_GRN_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.POCOLLABRATION_GRN_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <POCOLLABRATION_GRN_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.QUALITY_INSPECTION_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <QUALITY_INSPECTION_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.QUALITY_INSPECTION_LIST}
          element={
            <PrivateRoute>
              {" "}
              <QUALITY_INSPECTION_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.QUALITY_INSPECTION_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <QUALITY_INSPECTION_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.POCOLLABRATION_SES_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <POCOLLABRATION_SES_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.POCOLLABRATION_INVOICE_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <POCOLLABRATION_INVOICE_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.POCOLLABRATION_INVOICE_CREATION_SES}
          element={
            <PrivateRoute>
              {" "}
              <POCOLLABRATION_INVOICE_CREATION_SES />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.POCOLLABRATION_SCHEDULING_AGREEMENT}
          element={
            <PrivateRoute>
              {" "}
              <POCOLLABRATION_SCHEDULING_AGREEMENT />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.POCOLLABRATION_SERVICE_ENTRY_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <POCOLLABRATION_SERVICE_ENTRY_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        {/* SAPREPROCESS */}
        <Route
          exact
          path={SupplierConstantsList.SAPREPROCESS_GRN_REPROCESS}
          element={
            <PrivateRoute>
              {" "}
              <SAPREPROCESS_GRN_REPROCESS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SAPREPROCESS_SES_REPROCESS}
          element={
            <PrivateRoute>
              {" "}
              <SAPREPROCESS_SES_REPROCESS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SAPREPROCESS_INVOICE_REPROCESS}
          element={
            <PrivateRoute>
              {" "}
              <SAPREPROCESS_INVOICE_REPROCESS />{" "}
            </PrivateRoute>
          }
        />
        {/* ADMIN_MANAGE */}
        <Route
          exact
          path={SupplierConstantsList.ADMIN_MANAGE_ROLE}
          element={
            <PrivateRoute>
              {" "}
              <ADMIN_MANAGE_ROLE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.ADMIN_MANAGE_USER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <ADMIN_MANAGE_USER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.ADMIN_MANAGE_ADD_USER}
          element={
            <PrivateRoute>
              {" "}
              <ADMIN_MANAGE_ADD_USER />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.ADMIN_MANAGE_EDIT_USER}
          element={
            <PrivateRoute>
              {" "}
              <ADMIN_MANAGE_EDIT_USER />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.ADMIN_MANAGE_USER_LIST_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <ADMIN_MANAGE_USER_LIST_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        {/* AUCTION_REVERSE */}
        <Route
          exact
          path={SupplierConstantsList.AUCTION_REVERSE_AUCTION_LIST}
          element={
            <PrivateRoute>
              {" "}
              <AUCTION_REVERSE_AUCTION_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.AUCTION_REVERSE_AUCTION_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <AUCTION_REVERSE_AUCTION_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.AUCTION_REVERSE_AUCTION_HISTORY}
          element={
            <PrivateRoute>
              {" "}
              <AUCTION_REVERSE_AUCTION_HISTORY />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.AUCTION_FORWARD_AUCTION_LIST}
          element={
            <PrivateRoute>
              {" "}
              <AUCTION_FORWARD_AUCTION_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.AUCTION_FORWARD_AUCTION_HISTORY}
          element={
            <PrivateRoute>
              {" "}
              <AUCTION_FORWARD_AUCTION_HISTORY />{" "}
            </PrivateRoute>
          }
        />
        {/* CONTRACT_MANAGEMENT_CONTRACT */}
        <Route
          exact
          path={SupplierConstantsList.CONTRACTMANAGEMENT_CONTRACT_GENERATE_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CONTRACTMANAGEMENT_CONTRACT_GENERATE_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.CONTRACTMANAGEMENT_CONTRACT_REVIEW_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CONTRACTMANAGEMENT_CONTRACT_REVIEW_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={
            SupplierConstantsList.CONTRACTMANAGEMENT_CONTRACT_DRAFT_TO_FINAL_LIST
          }
          element={
            <PrivateRoute>
              {" "}
              <CONTRACTMANAGEMENT_CONTRACT_DRAFT_TO_FINAL_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.CONTRACTMANAGEMENT_MONITORING_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CONTRACTMANAGEMENT_MONITORING_LIST />{" "}
            </PrivateRoute>
          }
        />
        {/* GATEPASS */}
        <Route
          exact
          path={SupplierConstantsList.GATEPASS_GATEPASS_LIST}
          element={
            <PrivateRoute>
              {" "}
              <GATEPASS_GATEPASS_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.GATEPASS_GATEPASS_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <GATEPASS_GATEPASS_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.GATEPASS_GATEPASS_DETAIL_PAGE}
          element={
            <PrivateRoute>
              {" "}
              <GATEPASS_GATEPASS_DETAIL_PAGE />{" "}
            </PrivateRoute>
          }
        />
        {/* USER_MANUAL */}
        <Route
          exact
          path={SupplierConstantsList.USER_MANUAL_BUYER_MANUAL}
          element={
            <PrivateRoute>
              {" "}
              <USER_MANUAL_BUYER_MANUAL />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.USER_MANUAL_SUPPLIER_MANUAL}
          element={
            <PrivateRoute>
              {" "}
              <USER_MANUAL_SUPPLIER_MANUAL />{" "}
            </PrivateRoute>
          }
        />
        {/* DELEGATION */}
        <Route
          exact
          path={SupplierConstantsList.DELEGATION_TASK}
          element={
            <PrivateRoute>
              {" "}
              <DELEGATION_TASK />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.DELEGATION_USER}
          element={
            <PrivateRoute>
              {" "}
              <DELEGATION_USER />{" "}
            </PrivateRoute>
          }
        />
        {/* SINGLE_SOURCING */}
        <Route
          exact
          path={SupplierConstantsList.SINGLESOURCING_SINGLE_SOURCING_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <SINGLESOURCING_SINGLE_SOURCING_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SINGLESOURCING_SINGLE_SOURCING_LIST}
          element={
            <PrivateRoute>
              {" "}
              <SINGLESOURCING_SINGLE_SOURCING_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SINGLESOURCING_SINGLE_SOURCING_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <SINGLESOURCING_SINGLE_SOURCING_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        {/* ADVANCE_PAYMENT */}
        <Route
          exact
          path={
            SupplierConstantsList.ADVANCE_PAYMENT_ADVANCE_PAYMENT_REQUEST_CREATION
          }
          element={
            <PrivateRoute>
              {" "}
              <ADVANCE_PAYMENT_ADVANCE_PAYMENT_REQUEST_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={
            SupplierConstantsList.ADVANCE_PAYMENT_ADVANCE_PAYMENT_REQUEST_LIST
          }
          element={
            <PrivateRoute>
              {" "}
              <ADVANCE_PAYMENT_ADVANCE_PAYMENT_REQUEST_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={
            SupplierConstantsList.ADVANCE_PAYMENT_ADVANCE_PAYMENT_REQUEST_DETAILS
          }
          element={
            <PrivateRoute>
              {" "}
              <ADVANCE_PAYMENT_ADVANCE_PAYMENT_REQUEST_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        {/* GHG_SCOPE1 */}
        <Route
          exact
          path={SupplierConstantsList.GHG_SCOPE1_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <GHG_SCOPE1_CREATION />{" "}
            </PrivateRoute>
          }
        />
        {/* Reports */}
        <Route
          exact
          path={SupplierConstantsList.SUPPLIER_REPORTS}
          element={
            <PrivateRoute>
              {" "}
              <SUPPLIER_REPORTS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SUPPLIER_REPORT_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <SUPPLIER_REPORT_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/* MATERIAL_CATALOG */}
        <Route
          exact
          path={SupplierConstantsList.MATERIAL_CATALOG_LIST}
          element={
            <PrivateRoute>
              {" "}
              <MATERIAL_CATALOG_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.MATERIAL_CATALOG_MASTER}
          element={
            <PrivateRoute>
              {" "}
              <MATERIAL_CATALOG_MASTER />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.MATERIAL_CATALOG_SHOPWISE}
          element={
            <PrivateRoute>
              {" "}
              <MATERIAL_CATALOG_SHOPWISE />{" "}
            </PrivateRoute>
          }
        />

        {/* Category */}
        <Route
          exact
          path={SupplierConstantsList.CREATE_CATEGORY}
          element={
            <PrivateRoute>
              {" "}
              <CREATE_CATEGORY />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.CATEGORY_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CATEGORY_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.CATEGORY_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CATEGORY_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/* INVOICE_DOWN_PAYMENT */}
        <Route
          exact
          path={SupplierConstantsList.INVOICE_DOWN_PAYMENT_LIST}
          element={
            <PrivateRoute>
              {" "}
              <INVOICE_DOWN_PAYMENT_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.INVOICE_DOWN_PAYMENT_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <INVOICE_DOWN_PAYMENT_CREATE />{" "}
            </PrivateRoute>
          }
        />

        {/* SAP PO */}
        <Route
          exact
          path={SupplierConstantsList.SAP_PURCHASE_ORDER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <SAP_PURCHASE_ORDER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SAP_PURCHASE_ORDER_DETAIL_PAGE}
          element={
            <PrivateRoute>
              {" "}
              <SAP_PURCHASE_ORDER_DETAIL_PAGE />{" "}
            </PrivateRoute>
          }
        />

        {/* Eauction */}
        <Route
          exact
          path={SupplierConstantsList.EAUCTION_BUYERAUCTION_LIST}
          element={
            <PrivateRoute>
              {" "}
              <EAUCTION_BUYERAUCTION_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.EAUCTION_BUYERAUCTIONHISTORY_LIST}
          element={
            <PrivateRoute>
              {" "}
              <EAUCTION_BUYERAUCTIONHISTORY_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.EAUCTION_LIVE_AUCTION}
          element={
            <PrivateRoute>
              {" "}
              <EAUCTION_LIVE_AUCTION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.EAUCTION_BUYERAUCTION_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <EAUCTION_BUYERAUCTION_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.EAUCTION_BUYERAUCTION_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <EAUCTION_BUYERAUCTION_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.EAUCTION_LIVE_AUCTION_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <EAUCTION_LIVE_AUCTION_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.EAUCTION_SUPPLIER_AUCTION_LIST}
          element={
            <PrivateRoute>
              {" "}
              <EAUCTION_SUPPLIER_AUCTION_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.EAUCTION_SUPPLIER_AUCTION_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <EAUCTION_SUPPLIER_AUCTION_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.EAUCTION_SUPPLIER_LIVE_AUCTION_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <EAUCTION_SUPPLIER_LIVE_AUCTION_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.EAUCTION_SUPPLIER_LIVE_AUCTION_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <EAUCTION_SUPPLIER_LIVE_AUCTION_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/* Tender */}
        <Route
          exact
          path={SupplierConstantsList.CREATE_TENDER}
          element={
            <PrivateRoute>
              {" "}
              <CREATE_TENDER />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.TENDER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <TENDER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.TENEDER_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <TENEDER_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.TND_QTN_LIST}
          element={
            <PrivateRoute>
              {" "}
              <TND_QTN_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.TND_QTN_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <TND_QTN_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.TND_RFQ_LIST}
          element={
            <PrivateRoute>
              {" "}
              <TND_RFQ_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.TND_RFQ_DETAIL}
          element={
            <PrivateRoute>
              {" "}
              <TND_RFQ_DETAIL />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.TND_COMMERCIAL_EVAL}
          element={
            <PrivateRoute>
              {" "}
              <TND_COMMERCIAL_EVAL />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.TND_COMMERCIAL_EVAL_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <TND_COMMERCIAL_EVAL_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.TND_PURCHASE_ORDER_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <TND_PURCHASE_ORDER_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.TND_PURCHASE_ORDER_CREATION_P2}
          element={
            <PrivateRoute>
              {" "}
              <TND_PURCHASE_ORDER_CREATION_P2 />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SHOW_WISE_CATALOG}
          element={
            <PrivateRoute>
              {" "}
              <SHOW_WISE_CATALOG />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.PLANT_MASTER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <PLANT_MASTER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.PLANT_MASTER_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <PLANT_MASTER_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.PURCHASE_GROUP_LIST}
          element={
            <PrivateRoute>
              {" "}
              <PURCHASE_GROUP_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.PURCHASE_GROUP_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <PURCHASE_GROUP_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.PARTNERS_360_PAGE}
          element={
            <PrivateRoute>
              {" "}
              <PARTNERS_360_PAGE />{" "}
            </PrivateRoute>
          }
        />

        {/* ----------------------------------  Supplier END  ---------------------------------- */}

        {/* ----------------------------------  Customer START  ---------------------------------- */}

        {/* Common */}
        {/* <Route  exact path={CustomerConstantsList.APP_HOME}  element={ <PrivateRoute> <AppLandingPage/>  </PrivateRoute>  } /> */}
        {/* <Route  exact path={CustomerConstantsList.HOME}  element={ <PrivateRoute> <HOME/>  </PrivateRoute>  } /> */}
        <Route
          exact
          path={CustomerConstantsList.HOME_INTRO}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_HOME_INTRO />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.DASHBOARD}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_DASHBOARD />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.INBOX}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_INBOX />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.OUTBOX}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_OUTBOX />{" "}
            </PrivateRoute>
          }
        />

        {/* CUSTOMER */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_REGISTRATION}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_REGISTRATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_MASTER_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_MASTER_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_MASS_UPLOAD}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_MASS_UPLOAD />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_DETAILED_PAGE_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_DETAILED_PAGE_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_DETAILED_PAGE_WORKFLOW}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_DETAILED_PAGE_WORKFLOW />{" "}
            </PrivateRoute>
          }
        />

        {/* CUSTOMER V1 */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_REGISTER}
          element={<CUSTOMER_V1_REGISTER />}
        ></Route>
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_REGISTER_LOGIN}
          element={<CUSTOMER_V1_REGISTER_LOGIN />}
        ></Route>

        {/* //CUSTOMER_V1_REGISTER_DETAIL */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_REGISTER_DETAIL}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_REGISTER_DETAIL />{" "}
            </PrivateRoute>
          }
        />

        {/* PRESALES */}
        <Route
          exact
          path={CustomerConstantsList.PRESALES_INQUIRY_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <PRESALES_INQUIRY_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.PRESALES_INQUIRY_LIST}
          element={
            <PrivateRoute>
              {" "}
              <PRESALES_INQUIRY_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.PRESALES_INQUIRY_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <PRESALES_INQUIRY_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        <Route
          exact
          path={CustomerConstantsList.PRESALES_CUSTOMER_CREATE_QUOTATION}
          element={
            <PrivateRoute>
              {" "}
              <PRESALES_CUSTOMER_CREATE_QUOTATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.PRESALES_CUSTOMER_QUOTATION_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <PRESALES_CUSTOMER_QUOTATION_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.PRESALES_CUSTOMER_QUOTATION_LIST}
          element={
            <PrivateRoute>
              {" "}
              <PRESALES_CUSTOMER_QUOTATION_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.PRESALES_CUSTOMER_QUOTATION_CREATE_PO}
          element={
            <PrivateRoute>
              {" "}
              <PRESALES_CUSTOMER_QUOTATION_CREATE_PO />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.INQUIRY_COSTING_SHEET_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <INQUIRY_COSTING_SHEET_CREATION />{" "}
            </PrivateRoute>
          }
        />

        {/* SALES*/}
        <Route
          exact
          path={CustomerConstantsList.SALES_PURCHASE_ORDER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <SALES_PURCHASE_ORDER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.SALES_SALES_ORDER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <SALES_SALES_ORDER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.SALES_SALES_ORDER_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <SALES_SALES_ORDER_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.WORK_ORDER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <WORK_ORDER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.WORK_ORDER_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <WORK_ORDER_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.WORK_ORDER_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <WORK_ORDER_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.SALES_PURCHASE_ORDER_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <SALES_PURCHASE_ORDER_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.SALES_SALES_ORDER_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <SALES_SALES_ORDER_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        <Route
          exact
          path={CustomerConstantsList.SALES_DELIVERY_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <SALES_DELIVERY_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.SALES_DELIVERY_LIST}
          element={
            <PrivateRoute>
              {" "}
              <SALES_DELIVERY_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.SALES_DELIVERY_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <SALES_DELIVERY_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/* catalog */}
        <Route
          exact
          path={CustomerConstantsList.PRODUCT_CATALOG_LIST}
          element={
            <PrivateRoute>
              {" "}
              <PRODUCT_CATALOG_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.PRODUCT_CATALOG_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <PRODUCT_CATALOG_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.PRODUCT_CATALOG_MASTER}
          element={
            <PrivateRoute>
              {" "}
              <PRODUCT_CATALOG_MASTER />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.PRODUCT_CATALOG_SHOPWISE}
          element={
            <PrivateRoute>
              {" "}
              <PRODUCT_CATALOG_SHOPWISE />{" "}
            </PrivateRoute>
          }
        />

        {/* CSTOMER INVOICE */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_INVOICE_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_INVOICE_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_INVOICE_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_INVOICE_LIST />{" "}
            </PrivateRoute>
          }
        />

        {/* BILLING */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_BILLING}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_BILLING />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_BILLING_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_BILLING_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        {/* CUSTOMER FEED BACK */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_FEEDBACK}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_FEEDBACK />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_FEEDBACK_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_FEEDBACK_LIST />{" "}
            </PrivateRoute>
          }
        />
        {/* userManual */}
        <Route
          exact
          path={CustomerConstantsList.USER_MANUAL_CUSTOMER_MANUAL}
          element={
            <PrivateRoute>
              <USER_MANUAL_CUSTOMER_MANUAL />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.USER_MANUAL_MANAGER_MANUAL}
          element={
            <PrivateRoute>
              {" "}
              <USER_MANUAL_MANAGER_MANUAL />{" "}
            </PrivateRoute>
          }
        />

        {/* Reports */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_REPORTS}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_REPORTS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_REPORT_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_REPORT_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/*Costing Sheet  */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_COSTING_SHEET}
          element={<CUSTOMER_V1_COSTING_SHEET />}
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_COSTING_SHEET_LOGIN}
          element={<CUSTOMER_V1_COSTING_SHEET_LOGIN />}
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_COSTING_SHEET_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_COSTING_SHEET_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_COSTING_SHEET_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_COSTING_SHEET_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/* customer quotation */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_QUOTATION_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_QUOTATION_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_QUOTATION_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_QUOTATION_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_QUOTATION_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_QUOTATION_CREATION />{" "}
            </PrivateRoute>
          }
        />

        {/* KYC Registration form  */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_KYC_REGISTRATION_FORM}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_KYC_REGISTRATION_FORM />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_CUSTOMER_MASTER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_CUSTOMER_MASTER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_CUSTOMER_MASTER}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_CUSTOMER_MASTER />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_REFERENCE_CUSTOMER_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_REFERENCE_CUSTOMER_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/* SCHEDULING */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_ORDER_BOOKING_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_ORDER_BOOKING_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_ORDER_SCHEDULING_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_ORDER_SCHEDULING_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={
            CustomerConstantsList.CUSTOMER_V1_ORDER_COMPLETE_SCHEDULING_LIST
          }
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_ORDER_COMPLETE_SCHEDULING_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={
            CustomerConstantsList.CUSTOMER_V1_ORDER_CANCELLED_SCHEDULING_LIST
          }
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_ORDER_CANCELLED_SCHEDULING_LIST />
            </PrivateRoute>
          }
        />

        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_PRE_DISPATCH_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_PRE_DISPATCH_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_POST_DISPATCH_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_POST_DISPATCH_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_DISPATCH_CONFIRMATION_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_DISPATCH_CONFIRMATION_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={
            CustomerConstantsList.CUSTOMER_V1_DISPATCHED_CUSTOMER_CONFIRM_LIST
          }
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_DISPATCHED_CUSTOMER_CONFIRM_LIST />{" "}
            </PrivateRoute>
          }
        />

        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_IOM_CREDIT_NOTE_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_IOM_CREDIT_NOTE_LIST />{" "}
            </PrivateRoute>
          }
        />

        {/* //MATERAIL_MASTER */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_MATERIAL_MASTER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_MATERIAL_MASTER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_MATERIAL_MASTER_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_MATERIAL_MASTER_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_MATERIAL_MASTER_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_MATERIAL_MASTER_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/* //PLANT_MASTER*/}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_PLANT_MASTER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_PLANT_MASTER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_PLANT_MASTER_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_PLANT_MASTER_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_PLANT_MASTER_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_PLANT_MASTER_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/* TOLL_MASTER*/}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_TOLL_MASTER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_TOLL_MASTER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_TOLL_MASTER_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_TOLL_MASTER_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_TOLL_MASTER_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_TOLL_MASTER_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/* Approval Request form */}
        <Route
          exact
          path={
            CustomerConstantsList.CUSTOMER_V1_CREDIT_POLICY_REQUEST_FORM_DETAILS
          }
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_CREDIT_POLICY_REQUEST_FORM_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_CREDIT_POLICY_REQUEST_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_CREDIT_POLICY_REQUEST_LIST />{" "}
            </PrivateRoute>
          }
        />

        {/* Purchase order list */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_PURCHASE_ORDER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_PURCHASE_ORDER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_PURCHASE_ORDER_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_PURCHASE_ORDER_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_PURCHASE_ORDER_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_PURCHASE_ORDER_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/* transportaion */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_TRANSPORTAION_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_TRANSPORTAION_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V1_TRANSPORTAION_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V1_TRANSPORTAION_LIST />{" "}
            </PrivateRoute>
          }
        />

        {/*====================== CUSTOMER V2 ==========================*/}

        {/* CUSTOMER V1 */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_REGISTER}
          element={<CUSTOMER_V2_REGISTER />}
        ></Route>
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_REGISTER_LOGIN}
          element={<CUSTOMER_V2_REGISTER_LOGIN />}
        ></Route>

        {/* CUSTOMER_v2_list */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_CUSTOMER_MASTER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_CUSTOMER_MASTER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_CUSTOMER_MASTER}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_CUSTOMER_MASTER />{" "}
            </PrivateRoute>
          }
        />

        {/* //CUSTOMER_V1_REGISTER_DETAIL */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_REGISTER_DETAIL}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_REGISTER_DETAIL />{" "}
            </PrivateRoute>
          }
        />

        {/*Scheduling*/}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_ORDER_BOOKING_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_ORDER_BOOKING_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_ORDER_BOOKING_LIST_LINE_ITEM}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_ORDER_BOOKING_LIST_LINE_ITEM />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_ORDER_SCHEDULING_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_ORDER_SCHEDULING_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_PRE_DISPATCH_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_PRE_DISPATCH_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_POST_DISPATCH_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_POST_DISPATCH_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_LOADING_ADVICE_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_LOADING_ADVICE_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_LOADING_ADVICE_DETAIL}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_LOADING_ADVICE_DETAIL />{" "}
            </PrivateRoute>
          }
        />
        {/* cash request */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_CASH_REQUEST_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_CASH_REQUEST_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_CASH_REQUEST_UPDATE}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_CASH_REQUEST_UPDATE />{" "}
            </PrivateRoute>
          }
        />

        {/* Invoice */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_INVOICE_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_INVOICE_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_INVOICE_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_INVOICE_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_MANUAL_INVOICE_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_MANUAL_INVOICE_CREATION />{" "}
            </PrivateRoute>
          }
        />

        {/* customer dash board */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_DASHBOARD}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_DASHBOARD />{" "}
            </PrivateRoute>
          }
        />

        {/* RFQ */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_RFQ_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_RFQ_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_RFQ_CREATION_MANUAL}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_RFQ_CREATION_MANUAL />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_RFQ_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_RFQ_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_RFQ_DETAIL}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_RFQ_DETAIL />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_RFQ_COMMERCIAL_EVALUATION}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_RFQ_COMMERCIAL_EVALUATION />{" "}
            </PrivateRoute>
          }
        />

        {/* ------------------------------------Indent----------------------------------------------- */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_INDENT_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_INDENT_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_INDENT_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_INDENT_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_INDENT_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_INDENT_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/* -----------------------------------------------vendor--------------------------------------- */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_VENDOR_RFQ_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_VENDOR_RFQ_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_VENDOR_QUOTATION_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_VENDOR_QUOTATION_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_VENDOR_RFQ_DETAIL}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_VENDOR_RFQ_DETAIL />{" "}
            </PrivateRoute>
          }
        />

        {/* ------------------------------------Purchase Order----------------------------------------------- */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_PURCHASE_ORDER_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_PURCHASE_ORDER_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_PURCHASE_ORDER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_PURCHASE_ORDER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_PURCHASE_ORDER_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_PURCHASE_ORDER_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        {/* ------------------------------------ quotation ----------------------------------------------- */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_QUOTATION_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_QUOTATION_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_QUOTATION_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_QUOTATION_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_QUOTATION_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_QUOTATION_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/* Bulck upload */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_ORDER_BULCK_UPLOAD}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_ORDER_BULCK_UPLOAD />{" "}
            </PrivateRoute>
          }
        />

        {/*  */}
        <Route
          exact
          path={
            CustomerConstantsList.CUSTOMER_V2_CREDIT_POLICY_REQUEST_FORM_DETAILS
          }
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_CREDIT_POLICY_REQUEST_FORM_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_CREDIT_POLICY_REQUEST_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_CREDIT_POLICY_REQUEST_LIST />{" "}
            </PrivateRoute>
          }
        />
        {/* Purchase */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_PURCHASE_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_PURCHASE_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_PURCHASE_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_PURCHASE_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_PURCHASE_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_PURCHASE_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/* Ledgers */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_LEDGERS}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_LEDGERS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_LEDGERS_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_LEDGERS_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/* custome reports */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_CUSTOM_REPORTS}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_CUSTOM_REPORTS />{" "}
            </PrivateRoute>
          }
        />

        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_DAILY_EXPENSES}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_DAILY_EXPENSES />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V2_BANK_STATEMENT}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V2_BANK_STATEMENT />{" "}
            </PrivateRoute>
          }
        />

        {/*====================== CUSTOMER V3 ==========================*/}

        {/* customer-v3 */}
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V3_CUSTOMER_SELF_REGISTER}
          element={<CUSTOMER_V3_CUSTOMER_SELF_REGISTER />}
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V4_CUSTOMER_SELF_REGISTER}
          element={<CUSTOMER_V4_CUSTOMER_SELF_REGISTER />}
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V3_CUSTOMER_REGISTRATION}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V3_CUSTOMER_REGISTRATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V3_CUSTOMER_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V3_CUSTOMER_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V4_CUSTOMER_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V4_CUSTOMER_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V3_CUSTOMER_WORKFLOW_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V3_CUSTOMER_WORKFLOW_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V4_CUSTOMER_WORKFLOW_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V4_CUSTOMER_WORKFLOW_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V3_CUSTOMER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V3_CUSTOMER_LIST />{" "}
            </PrivateRoute>
          }
        />

        {/*====================== CUSTOMER V4 ==========================*/}

        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V4_MATERIAL_PRICE_BREAKDOWN}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V4_MATERIAL_PRICE_BREAKDOWN />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={
            CustomerConstantsList.CUSTOMER_V4_MATERIAL_PRICE_BREAKDOWN_DETAILS
          }
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V4_MATERIAL_PRICE_BREAKDOWN_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V4_CUSTOMER_SALES_BREAKDOWN}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V4_CUSTOMER_SALES_BREAKDOWN />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={
            CustomerConstantsList.CUSTOMER_V4_CUSTOMER_SALES_BREAKDOWN_DETAILS
          }
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V4_CUSTOMER_SALES_BREAKDOWN_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V4_QUOTATION_ESTIMATE}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V4_QUOTATION_ESTIMATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMER_V4_QUOTATION_ESTIMATE_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V4_QUOTATION_ESTIMATE_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        <Route
          exact
          path={
            CustomerConstantsList.CUSTOMER_V4_FINANCE_PRICE_BREAKDOWN_CREATION
          }
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMER_V4_FINANCE_PRICE_BREAKDOWN_CREATION />{" "}
            </PrivateRoute>
          }
        />

        {/*====================== CUSTOMER V5 ==========================*/}

        <Route
          exact
          path={CustomerConstantsList.EQUIPMENT_MASTER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <EQUIPMENT_MASTER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMERV5_RENTREQUEST_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMERV5_RENTREQUEST_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMERV5_RENTREQUEST_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMERV5_RENTREQUEST_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUSTOMERV5_RENTREQUEST_MASTER}
          element={
            <PrivateRoute>
              {" "}
              <CUSTOMERV5_RENTREQUEST_MASTER />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUST_GATE_ENTRY_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUST_GATE_ENTRY_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUST_GATE_ENTRY_UPDATE}
          element={
            <PrivateRoute>
              {" "}
              <CUST_GATE_ENTRY_UPDATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUST_GATE_ENTRY_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <CUST_GATE_ENTRY_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUST_QUALITY_INSPECTION_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CUST_QUALITY_INSPECTION_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUST_QUALITY_INPSECTION_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <CUST_QUALITY_INPSECTION_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.CUST_QUALITY_INPSECTION_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CUST_QUALITY_INPSECTION_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.WO_DELIVERY_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <WO_DELIVERY_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.WO_DELIVERY_LIST}
          element={
            <PrivateRoute>
              {" "}
              <WO_DELIVERY_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={CustomerConstantsList.WO_DELIVERY_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <WO_DELIVERY_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/* ----------------------------------  Customer END  ---------------------------------- */}

        {/* ----------------------------------  logictic start  ---------------------------------- */}

        <Route
          exact
          path={LogisticsConstantsList.HOME_INTRO}
          element={
            <PrivateRoute>
              {" "}
              <LOGISTICS_HOME_INTRO />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LogisticsConstantsList.DASHBOARD}
          element={
            <PrivateRoute>
              {" "}
              <LOGISTICS_DASHBOARD />{" "}
            </PrivateRoute>
          }
        />

        <Route
          exact
          path={LogisticsConstantsList.LOGISTICS_MASTER_VEHICLE_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <LOGISTICS_MASTER_VEHICLE_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LogisticsConstantsList.LOGISTICS_MASTER_VEHICLE_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <LOGISTICS_MASTER_VEHICLE_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LogisticsConstantsList.LOGISTICS_MASTER_VEHICLE_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LOGISTICS_MASTER_VEHICLE_LIST />{" "}
            </PrivateRoute>
          }
        />

        {/* DRIVER */}
        <Route
          exact
          path={LogisticsConstantsList.LOGISTICS_MASTER_DRIVER_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <LOGISTICS_MASTER_DRIVER_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LogisticsConstantsList.LOGISTICS_MASTER_DRIVER_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <LOGISTICS_MASTER_DRIVER_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LogisticsConstantsList.LOGISTICS_MASTER_DRIVER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LOGISTICS_MASTER_DRIVER_LIST />{" "}
            </PrivateRoute>
          }
        />

        {/*Transporter */}
        <Route
          exact
          path={LogisticsConstantsList.LOGISTICS_TRANSPORT_REQUEST_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <LOGISTICS_TRANSPORT_REQUEST_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LogisticsConstantsList.LOGISTICS_TRANSPORT_REQUEST_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LOGISTICS_TRANSPORT_REQUEST_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LogisticsConstantsList.LOGISTICS_TRANSPORT_REQUEST_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <LOGISTICS_TRANSPORT_REQUEST_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/* Master/Transporter */}
        <Route
          exact
          path={
            LogisticsConstantsList.LOGISTICS_MASTER_TRANSPORTER_REGISTRATION
          }
          element={
            <PrivateRoute>
              {" "}
              <LOGISTICS_MASTER_TRANSPORTER_REGISTRATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LogisticsConstantsList.LOGISTICS_MASTER_TRANSPORTER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LOGISTICS_MASTER_TRANSPORTER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LogisticsConstantsList.LOGISTICS_MASTER_TRANSPORTER_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <LOGISTICS_MASTER_TRANSPORTER_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/* Gate Entry */}
        <Route
          exact
          path={LogisticsConstantsList.LOGISTICS_IN_WORD_OUT_WORD_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LOGISTICS_IN_WORD_OUT_WORD_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LogisticsConstantsList.LOGISTICS_GATE_ENTRY_UPDATE}
          element={
            <PrivateRoute>
              {" "}
              <LOGISTICS_GATE_ENTRY_UPDATE />{" "}
            </PrivateRoute>
          }
        />

        {/* Fuel Entery */}
        <Route
          exact
          path={LogisticsConstantsList.LOGISTICS_FUEL_ENTRY_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LOGISTICS_FUEL_ENTRY_LIST />{" "}
            </PrivateRoute>
          }
        />

        {/* Fuel Entery */}
        <Route
          exact
          path={LogisticsConstantsList.LOGISTICS_MASTER_BUNK_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <LOGISTICS_MASTER_BUNK_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LogisticsConstantsList.LOGISTICS_MASTER_BUNK_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <LOGISTICS_MASTER_BUNK_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LogisticsConstantsList.LOGISTICS_MASTER_BUNK_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LOGISTICS_MASTER_BUNK_LIST />{" "}
            </PrivateRoute>
          }
        />

        {/* Bank */}
        <Route
          exact
          path={LogisticsConstantsList.LOGISTICS_BANK_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LOGISTICS_BANK_LIST />{" "}
            </PrivateRoute>
          }
        />
        {/* ----------------------------------  logictic End  ---------------------------------- */}

        {/* ----------------------------------  inventory start  ---------------------------------- */}
        <Route
          exact
          path={HRConstants.HOME_INTRO}
          element={
            <PrivateRoute>
              {" "}
              <HR_HOME_INTRO />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={HRConstants.DASHBOARD}
          element={
            <PrivateRoute>
              {" "}
              <HR_DASHBOARD />{" "}
            </PrivateRoute>
          }
        />

        {/* Stock List */}
        <Route
          exact
          path={WarehouseConstants.WH_STOCK_LIST}
          element={
            <PrivateRoute>
              {" "}
              <WH_STOCK_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={WarehouseConstants.WH_STOCK_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <WH_STOCK_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={WarehouseConstants.WH_STOCK_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <WH_STOCK_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/* ware-house */}
        <Route
          exact
          path={WarehouseConstants.WH_WAREHOUSE_LIST}
          element={
            <PrivateRoute>
              {" "}
              <WH_WAREHOUSE_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={WarehouseConstants.WH_WAREHOUSE_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <WH_WAREHOUSE_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={WarehouseConstants.WH_WAREHOUSE_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <WH_WAREHOUSE_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/* Order-creation */}
        <Route
          exact
          path={WarehouseConstants.WH_ORDER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <WH_ORDER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={WarehouseConstants.WH_ORDER_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <WH_ORDER_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={WarehouseConstants.WH_ORDER_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <WH_ORDER_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/* ----------------------------------  inventory End  ---------------------------------- */}

        {/* ----------------------------------  PLM start  ---------------------------------- */}
        <Route
          exact
          path={PLMConstantsList.HOME_INTRO}
          element={
            <PrivateRoute>
              {" "}
              <PLM_HOME_INTRO />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={PLMConstantsList.DASHBOARD}
          element={
            <PrivateRoute>
              {" "}
              <PLM_DASHBOARD />{" "}
            </PrivateRoute>
          }
        />

        {/*  product Matrix */}
        <Route
          exact
          path={PLMConstantsList.PRODUCT_ARTICLES_ARTICLE_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <PRODUCT_ARTICLES_ARTICLE_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={PLMConstantsList.PRODUCT_ARTICLES_ARTICLE_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <PRODUCT_ARTICLES_ARTICLE_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={PLMConstantsList.PRODUCT_ARTICLES_ARTICLE_LIST}
          element={
            <PrivateRoute>
              {" "}
              <PRODUCT_ARTICLES_ARTICLE_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={PLMConstantsList.PRODUCT_ARTICLES_ARTICLE}
          element={
            <PrivateRoute>
              {" "}
              <PRODUCT_ARTICLES_ARTICLE />{" "}
            </PrivateRoute>
          }
        />

        <Route
          exact
          path={PLMConstantsList.PRODUCT_ARTICLE_MASTER_BULK_UPLOAD}
          element={
            <PrivateRoute>
              {" "}
              <PRODUCT_ARTICLE_MASTER_BULK_UPLOAD />{" "}
            </PrivateRoute>
          }
        />
        {/* Product Matrix  */}
        <Route
          exact
          path={PLMConstantsList.PRODUCT_MATRIX_PRODUCTMATRIX_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <PRODUCT_MATRIX_PRODUCTMATRIX_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={PLMConstantsList.PRODUCT_MATRIX_PRODUCTMATRIX_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <PRODUCT_MATRIX_PRODUCTMATRIX_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={PLMConstantsList.PRODUCT_MATRIX_PRODUCTMATRIX_CREATIONP2}
          element={
            <PrivateRoute>
              {" "}
              <PRODUCT_MATRIX_PRODUCTMATRIX_CREATIONP2 />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={PLMConstantsList.PRODUCT_MATRIX_PRODUCTMATRIX_LIST}
          element={
            <PrivateRoute>
              {" "}
              <PRODUCT_MATRIX_PRODUCTMATRIX_LIST />{" "}
            </PrivateRoute>
          }
        />
        {/* ----------------------------------  PLM End  ---------------------------------- */}

        {/* ----------------------------------  PDM start  ---------------------------------- */}
        <Route
          exact
          path={PDMConstantsList.HOME_INTRO}
          element={
            <PrivateRoute>
              {" "}
              <PDM_HOME_INTRO />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={PDMConstantsList.DASHBOARD}
          element={
            <PrivateRoute>
              {" "}
              <PDM_DASHBOARD />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={PDMConstantsList.INBOX}
          element={
            <PrivateRoute>
              {" "}
              <PDM_INBOX />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={PDMConstantsList.OUTBOX}
          element={
            <PrivateRoute>
              {" "}
              <PDM_OUTBOX />{" "}
            </PrivateRoute>
          }
        />

        {/* ----------------------------------  PDM End  ---------------------------------- */}

        {/* ----------------------------------  AP_AUTO start  ---------------------------------- */}
        <Route
          exact
          path={AP_AUTOConstantsList.HOME_INTRO}
          element={
            <PrivateRoute>
              {" "}
              <AP_AUTO_HOME_INTRO />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.DASHBOARD}
          element={
            <PrivateRoute>
              {" "}
              <AP_AUTO_DASHBOARD />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.INBOX}
          element={
            <PrivateRoute>
              {" "}
              <AP_AUTO_INBOX />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.OUTBOX}
          element={
            <PrivateRoute>
              {" "}
              <AP_AUTO_OUTBOX />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.VIEWNOTIFI}
          element={
            <PrivateRoute>
              {" "}
              <VIEWNOTIFI />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.AP_SUPPLIER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <AP_SUPPLIER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.AR_CUSTOMER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <AR_CUSTOMER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.AP_INVOICE_LIST}
          element={
            <PrivateRoute>
              {" "}
              <AP_INVOICE_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.AR_INVOICE_LIST}
          element={
            <PrivateRoute>
              {" "}
              <AR_INVOICE_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.AP_PURCHASE_ORDER}
          element={
            <PrivateRoute>
              {" "}
              <AP_PURCHASE_ORDER />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.AR_SALES_ORDER}
          element={
            <PrivateRoute>
              {" "}
              <AR_SALES_ORDER />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.AP_INVOICE_AUTO_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <AP_INVOICE_AUTO_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.AR_INVOICE_AUTO_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <AR_INVOICE_AUTO_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.AP_INV_DETAIL}
          element={
            <PrivateRoute>
              {" "}
              <AP_INV_DETAIL />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.AR_INV_DETAIL}
          element={
            <PrivateRoute>
              {" "}
              <AR_INV_DETAIL />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.BUDGET_CARDS}
          element={
            <PrivateRoute>
              {" "}
              <BUDGET_CARDS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.BUDGET_LIST}
          element={
            <PrivateRoute>
              {" "}
              <BUDGET_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.AP_SUPPLIER_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <AP_SUPPLIER_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.AR_CUST_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <AR_CUST_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.AR_CUST_DETAIL}
          element={
            <PrivateRoute>
              {" "}
              <AR_CUST_DETAIL />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.AP_PAYMENT_OUT}
          element={
            <PrivateRoute>
              {" "}
              <AP_PAYMENT_OUT />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.AR_PAYMENT_IN}
          element={
            <PrivateRoute>
              {" "}
              <AR_PAYMENT_IN />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.AP_WORK_FLOW}
          element={
            <PrivateRoute>
              {" "}
              <AP_WORK_FLOW />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.AP_CREATE_PO}
          element={
            <PrivateRoute>
              {" "}
              <AP_CREATE_PO />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.AP_PO_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <AP_PO_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.AR_CREATE_SO}
          element={
            <PrivateRoute>
              {" "}
              <AR_CREATE_SO />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.AP_EXP_INV_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <AP_EXP_INV_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.AP_EXP_INV_LIST}
          element={
            <PrivateRoute>
              {" "}
              <AP_EXP_INV_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.AP_EXP_INV_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <AP_EXP_INV_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.AP_AUTO_REPORTS}
          element={
            <PrivateRoute>
              {" "}
              <AP_AUTO_REPORTS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.AP_AUTO_REPORTS_DETAIL}
          element={
            <PrivateRoute>
              {" "}
              <AP_AUTO_REPORTS_DETAIL />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.AP_EXP_PAY_OUT}
          element={
            <PrivateRoute>
              {" "}
              <AP_EXP_PAY_OUT />{" "}
            </PrivateRoute>
          }
        />
        {/* ----------------------------------  AP_AUTO End  ---------------------------------- */}

        {/*----------------------------------------ASSET_APP START--------------------------------------------------*/}
        <Route
          exact
          path={ASSETConstants.HOME_INTRO}
          element={
            <PrivateRoute>
              {" "}
              <ASSTE_HOME_INTRO />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={ASSETConstants.DASHBOARD}
          element={
            <PrivateRoute>
              {" "}
              <ASSET_DASHBOARD />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={ASSETConstants.INBOX}
          element={
            <PrivateRoute>
              {" "}
              <ASSET_INBOX />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={ASSETConstants.OUTBOX}
          element={
            <PrivateRoute>
              {" "}
              <ASSET_OUTBOX />{" "}
            </PrivateRoute>
          }
        />

        {/*----------------------------------------ASSET_APP END--------------------------------------------------*/}

        {/*----------------------------------------WAREHOUSE_APP START--------------------------------------------------*/}
        <Route
          exact
          path={WarehouseConstants.HOME_INTRO}
          element={
            <PrivateRoute>
              {" "}
              <WAREHOUSE_HOME_INTRO />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={WarehouseConstants.DASHBOARD}
          element={
            <PrivateRoute>
              {" "}
              <WAREHOUSE_DASHBOARD />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={WarehouseConstants.INBOX}
          element={
            <PrivateRoute>
              {" "}
              <WAREHOUSE_INBOX />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={WarehouseConstants.OUTBOX}
          element={
            <PrivateRoute>
              {" "}
              <WAREHOUSE_OUTBOX />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={WarehouseConstants.WAREHOUSE_MATERIAL_LIST}
          element={
            <PrivateRoute>
              {" "}
              <WAREHOUSE_MATERIAL_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={WarehouseConstants.WH_MAT_INDENT_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <WH_MAT_INDENT_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={WarehouseConstants.WH_MAT_INDENT_LIST}
          element={
            <PrivateRoute>
              {" "}
              <WH_MAT_INDENT_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={WarehouseConstants.WH_MAT_INDENT_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <WH_MAT_INDENT_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={WarehouseConstants.WH_CREATE_PO}
          element={
            <PrivateRoute>
              {" "}
              <WH_CREATE_PO />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={WarehouseConstants.WH_PO_LIST}
          element={
            <PrivateRoute>
              {" "}
              <WH_PO_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={WarehouseConstants.WH_PO_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <WH_PO_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/*----------------------------------------WAREHOUSE_APP END--------------------------------------------------*/}

        {/*----------------------------------------FACTORY_APP START--------------------------------------------------*/}
        <Route
          exact
          path={FactoryConstants.HOME_INTRO}
          element={
            <PrivateRoute>
              {" "}
              <FACTORY_MNG_HOME_INTRO />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={FactoryConstants.DASHBOARD}
          element={
            <PrivateRoute>
              {" "}
              <FACTORY_MNG_DASHBOARD />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={FactoryConstants.INBOX}
          element={
            <PrivateRoute>
              {" "}
              <FACTORY_MNG_INBOX />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={FactoryConstants.OUTBOX}
          element={
            <PrivateRoute>
              {" "}
              <FACTORY_MNG_OUTBOX />{" "}
            </PrivateRoute>
          }
        />

        {/*----------------------------------------FACTORY_APP END--------------------------------------------------*/}

        {/*----------------------------------------SMART_CONSTRUNCTION_APP START--------------------------------------------------*/}
        <Route
          exact
          path={SCConstants.HOME_INTRO}
          element={
            <PrivateRoute>
              {" "}
              <SC_HOME_INTRO />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.DASHBOARD}
          element={
            <PrivateRoute>
              {" "}
              <SC_DASHBOARD />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.INBOX}
          element={
            <PrivateRoute>
              {" "}
              <SC_INBOX />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.OUTBOX}
          element={
            <PrivateRoute>
              {" "}
              <SC_OUTBOX />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.CONSTRUCTION_ESTIMATE_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_ESTIMATE_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.CONSTRUCTION_MATERIAL_PRICE_BREAKDOWN}
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_MATERIAL_PRICE_BREAKDOWN />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.CONSTRUCTION_MATERIAL_PRICE_BREAKDOWN_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_MATERIAL_PRICE_BREAKDOWN_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.CONSTRUCTION_CUSTOMER_SALES_BREAKDOWN}
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_CUSTOMER_SALES_BREAKDOWN />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.CONSTRUCTION_CUSTOMER_SALES_BREAKDOWN_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_CUSTOMER_SALES_BREAKDOWN_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.CONSTRUCTION_QUOTATION_ESTIMATE}
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_QUOTATION_ESTIMATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.CONSTRUCTION_QUOTATION_ESTIMATE_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_QUOTATION_ESTIMATE_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.CONSTRUCTION_FINANCE_PRICE_BREAKDOWN_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_FINANCE_PRICE_BREAKDOWN_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.CONSTRUCTION_CUSTOMER_ESTIMATE_E1}
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_CUSTOMER_ESTIMATE_E1 />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.CONSTRUCTION_CUSTOMER_ESTIMATE_SPECIFICATION}
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_CUSTOMER_ESTIMATE_SPECIFICATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.CONSTRUCTION_CUSTOMER_ESTIMATE_MATERIAL_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_CUSTOMER_ESTIMATE_MATERIAL_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.CONSTRUCTION_QUOTATION_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_QUOTATION_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.CONSTRUCTION_JOB_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_JOB_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.CONSTRUCTION_ENTRY_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_ENTRY_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.CONSTRUCTION_ESTIMATE_SPECIFICATION_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_ESTIMATE_SPECIFICATION_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={
            SCConstants.CONSTRUCTION_CUSTOMER_ESTIMATE_SPECIFICATION_DETAILS
          }
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_CUSTOMER_ESTIMATE_SPECIFICATION_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={
            SCConstants.CONSTRUCTION_CUSTOMER_ESTIMATE_SPECIFICATION_DETAILS_REVISION
          }
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_CUSTOMER_ESTIMATE_SPECIFICATION_DETAILS_REVISION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={
            SCConstants.CONSTRUCTION_CUSTOMER_ESTIMATE_SPECIFICATION_WORKFLOW
          }
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_CUSTOMER_ESTIMATE_SPECIFICATION_WORKFLOW />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.CONSTRUCTION_CUSTOMER_ESTIMATE_CREATION__WORKFLOW}
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_CUSTOMER_ESTIMATE_CREATION__WORKFLOW />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.CONSTRUCTION_MATERIAL_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_MATERIAL_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.CONSTRUCTION_CUST_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_CUST_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.CONSTRUCTION_CUST_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_CUST_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.CONSTRUCTION_INQ_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_INQ_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.CONSTRUCTION_INQ_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_INQ_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.CONSTRUCTION_QNT_LIST}
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_QNT_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.CONSTRUCTION_QNT_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_QNT_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/* Reports */}
        <Route
          exact
          path={SCConstants.CONSTRUCTION_REPORTS}
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_REPORTS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SCConstants.CONSTRUCTION_REPORT_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <CONSTRUCTION_REPORT_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        {/*----------------------------------------SMART_CONSTRUNCTION_APP  END--------------------------------------------------*/}

        {/*----------------------------------------AP_AUTOMATION_APP START--------------------------------------------------*/}
        <Route
          exact
          path={AP_AUTOConstantsList.HOME_INTRO}
          element={
            <PrivateRoute>
              {" "}
              <APAUTOMATION_HOME_INTRO />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.DASHBOARD}
          element={
            <PrivateRoute>
              {" "}
              <APAUTOMATION_DASHBOARD />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.INBOX}
          element={
            <PrivateRoute>
              {" "}
              <APAUTOMATION_INBOX />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AP_AUTOConstantsList.OUTBOX}
          element={
            <PrivateRoute>
              {" "}
              <APAUTOMATION_OUTBOX />{" "}
            </PrivateRoute>
          }
        />

        {/*----------------------------------------AP_AUTOMATION_APP  END--------------------------------------------------*/}

        {/*----------------------------------------LEDGER_APP START--------------------------------------------------*/}
        <Route
          exact
          path={LedgerConstants.HOME_INTRO}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_HOME_INTRO />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.DASHBOARD}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_DASHBOARD />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.INBOX}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_INBOX />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.OUTBOX}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_OUTBOX />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_CASH_REQUEST_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_CASH_REQUEST_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_CASH_REQUEST_UPDATE}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_CASH_REQUEST_UPDATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_CASH_REQUEST_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_CASH_REQUEST_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_BANK_STATEMENT}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_BANK_STATEMENT />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_DAILY_EXPENSES}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_DAILY_EXPENSES />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_CASH_EXPENSES_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_CASH_EXPENSES_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_BANK_STATEMENT_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_BANK_STATEMENT_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_CASH_EXPENSES2_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_CASH_EXPENSES2_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_CASH_EXPENSES_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_CASH_EXPENSES_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_PAYMENT_VOUCHER}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_PAYMENT_VOUCHER />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_PAYMENT_RECEIPT}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_PAYMENT_RECEIPT />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_INVOICE_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_INVOICE_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_MANUAL_INVOICE_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_MANUAL_INVOICE_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_MANUAL_INVOICE_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_MANUAL_INVOICE_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_INVOICE_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_INVOICE_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_LOADING_ADVICE_DETAIL}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_LOADING_ADVICE_DETAIL />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_RFQ_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_RFQ_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_RFQ_CREATION_MANUAL}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_RFQ_CREATION_MANUAL />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_RFQ_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_RFQ_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_RFQ_DETAIL}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_RFQ_DETAIL />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_RFQ_COMMERCIAL_EVALUATION}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_RFQ_COMMERCIAL_EVALUATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_INDENT_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_INDENT_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_INDENT_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_INDENT_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_INDENT_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_INDENT_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_PURCHASE_ORDER_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_PURCHASE_ORDER_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_PURCHASE_ORDER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_PURCHASE_ORDER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_PURCHASE_ORDER_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_PURCHASE_ORDER_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_PURCHASE_ORDER_DELIVERY_CONFIRM}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_PURCHASE_ORDER_DELIVERY_CONFIRM />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_PURCHASE_ORDER_DELIVERY_DETIALS}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_PURCHASE_ORDER_DELIVERY_DETIALS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_PURCHASE_ORDER_PAYMENT_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_PURCHASE_ORDER_PAYMENT_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_COMPANY_REGISTRATION}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_COMPANY_REGISTRATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_COMPANY_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_COMPANY_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_COMPANY_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_COMPANY_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_MATERIAL_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_MATERIAL_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_PETTY_CASH_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_PETTY_CASH_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_PETTY_CASH_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_PETTY_CASH_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_SUPPILER_REGISTRATION}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_SUPPILER_REGISTRATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_SUPPILER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_SUPPILER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_SUPPILER_MASS_UPLOAD}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_SUPPILER_MASS_UPLOAD />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_SUPPLIER_MASTER_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_SUPPLIER_MASTER_CREATE />{" "}
            </PrivateRoute>
          }
        />

        <Route
          exact
          path={LedgerConstants.LEDGER_MASTER_VEHICLE_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_MASTER_VEHICLE_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_MASTER_VEHICLE_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_MASTER_VEHICLE_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_MASTER_VEHICLE_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_MASTER_VEHICLE_LIST />{" "}
            </PrivateRoute>
          }
        />

        {/* DRIVER */}
        <Route
          exact
          path={LedgerConstants.LEDGER_MASTER_DRIVER_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_MASTER_DRIVER_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_MASTER_DRIVER_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_MASTER_DRIVER_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_MASTER_DRIVER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_MASTER_DRIVER_LIST />{" "}
            </PrivateRoute>
          }
        />

        {/*Transporter */}
        <Route
          exact
          path={LedgerConstants.LEDGER_TRANSPORT_REQUEST_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_TRANSPORT_REQUEST_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_TRANSPORT_REQUEST_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_TRANSPORT_REQUEST_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_TRANSPORT_REQUEST_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_TRANSPORT_REQUEST_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/* Master/Transporter */}
        <Route
          exact
          path={LedgerConstants.LEDGER_MASTER_TRANSPORTER_REGISTRATION}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_MASTER_TRANSPORTER_REGISTRATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_MASTER_TRANSPORTER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_MASTER_TRANSPORTER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_MASTER_TRANSPORTER_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_MASTER_TRANSPORTER_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/* Gate Entry */}
        <Route
          exact
          path={LedgerConstants.LEDGER_IN_WORD_OUT_WORD_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_IN_WORD_OUT_WORD_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_GATE_ENTRY_UPDATE}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_GATE_ENTRY_UPDATE />{" "}
            </PrivateRoute>
          }
        />

        {/* Fuel Entery */}
        <Route
          exact
          path={LedgerConstants.LEDGER_FUEL_ENTRY_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_FUEL_ENTRY_LIST />{" "}
            </PrivateRoute>
          }
        />

        {/* Fuel Entery */}
        <Route
          exact
          path={LedgerConstants.LEDGER_MASTER_BUNK_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_MASTER_BUNK_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_MASTER_BUNK_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_MASTER_BUNK_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_MASTER_BUNK_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_MASTER_BUNK_LIST />{" "}
            </PrivateRoute>
          }
        />

        {/* Bank */}
        <Route
          exact
          path={LedgerConstants.LEDGER_BANK_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_BANK_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_QUOTATION_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_QUOTATION_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_QUOTATION_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_QUOTATION_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_QUOTATION_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_QUOTATION_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_ORDER_BOOKING}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_ORDER_BOOKING />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_ORDER_SCHEDULING}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_ORDER_SCHEDULING />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_LOADING_ADVICE}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_LOADING_ADVICE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_CREDIT_POLICY_REQUEST_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_CREDIT_POLICY_REQUEST_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_CREDIT_POLICY_REQUEST_FORM_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_CREDIT_POLICY_REQUEST_FORM_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_CUSTOM_REPORTS}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_CUSTOM_REPORTS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_SALES_OFFICER_CUSTOM_REPORTS}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_SALES_OFFICER_CUSTOM_REPORTS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_PURCHASE_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_PURCHASE_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_CUSTOMER_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_CUSTOMER_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_CUSTOMER_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_CUSTOMER_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_TRANSPORT_REQ_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_TRANSPORT_REQ_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_TRANSPORT_REQ_LIST_ACK}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_TRANSPORT_REQ_LIST_ACK />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_DELIVERY_PAYMENT_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_DELIVERY_PAYMENT_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_FUEL_ENTRY_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_FUEL_ENTRY_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_EMP_LIST}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_EMP_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_EMP_REGISTRATION}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_EMP_REGISTRATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_EMP_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_EMP_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={LedgerConstants.LEDGER_PURCHASE_CREATION}
          element={
            <PrivateRoute>
              {" "}
              <LEDGER_PURCHASE_CREATION />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.EMAIL_SENDER}
          element={
            <PrivateRoute>
              {" "}
              <EMAIL_SENDER />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.SENT_EMAIL}
          element={
            <PrivateRoute>
              {" "}
              <SENT_EMAIL />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={SupplierConstantsList.EMAIL_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <EMAIL_DETAILS />{" "}
            </PrivateRoute>
          }
        />

        {/*----------------------------------------LEDGER_APP  END--------------------------------------------------*/}
        {/*----------------------------------------HR_APP  START--------------------------------------------------*/}
        <Route
          exact
          path={HRConstants.HR_EMP_LIST}
          element={
            <PrivateRoute>
              {" "}
              <HR_EMP_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={HRConstants.HR_EMP_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <HR_EMP_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={HRConstants.HR_EMP_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <HR_EMP_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={HRConstants.ATD_CAL}
          element={
            <PrivateRoute>
              {" "}
              <ATD_CAL />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={HRConstants.HR_ATD_LIST}
          element={
            <PrivateRoute>
              {" "}
              <HR_ATD_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={HRConstants.HR_ATD_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <HR_ATD_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={HRConstants.HR_DOC_LIST}
          element={
            <PrivateRoute>
              {" "}
              <HR_DOC_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={HRConstants.HR_DOC_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <HR_DOC_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={HRConstants.HR_DOC_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <HR_DOC_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={HRConstants.HR_TASK_LIST}
          element={
            <PrivateRoute>
              {" "}
              <HR_TASK_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={HRConstants.HR_TASK_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <HR_TASK_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={HRConstants.HR_TASK_CAL}
          element={
            <PrivateRoute>
              {" "}
              <HR_TASK_CAL />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={HRConstants.HR_ORG_STRUCTURE}
          element={
            <PrivateRoute>
              {" "}
              <HR_ORG_STRUCTURE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={HRConstants.HR_EXPENSES_LIST}
          element={
            <PrivateRoute>
              {" "}
              <HR_EXPENSES_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={HRConstants.HR_EXPENSES_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <HR_EXPENSES_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={HRConstants.HR_CLIENT_LIST}
          element={
            <PrivateRoute>
              {" "}
              <HR_CLIENT_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={HRConstants.HR_CLIENT_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <HR_CLIENT_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={HRConstants.HR_CLIENT_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <HR_CLIENT_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={HRConstants.HR_PROJECT_LIST}
          element={
            <PrivateRoute>
              {" "}
              <HR_PROJECT_LIST />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={HRConstants.HR_PROJECT_CREATE}
          element={
            <PrivateRoute>
              {" "}
              <HR_PROJECT_CREATE />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={HRConstants.HR_PROJECT_DETAILS}
          element={
            <PrivateRoute>
              {" "}
              <HR_PROJECT_DETAILS />{" "}
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={HRConstants.HR_RECEIPTS_LIST}
          element={
            <PrivateRoute>
              {" "}
              <HR_RECEIPTS_LIST />{" "}
            </PrivateRoute>
          }
        />
       

        {/*----------------------------------------HR_APP  END--------------------------------------------------*/}
        {/*----------------------------------------ACCOUNTS  START--------------------------------------------------*/}
        <Route exact path={AccountsConstants.LEDGER_LIST} element={<PrivateRoute><LedgerList /></PrivateRoute>} />
        <Route exact path={AccountsConstants.LEDGER_CREATE} element={<PrivateRoute><LedgerForm /></PrivateRoute>} />
        <Route exact path={AccountsConstants.LEDGER_EDIT} element={<PrivateRoute><LedgerForm /></PrivateRoute>} />
        <Route exact path={AccountsConstants.SALES_CREATE} element={<PrivateRoute><VoucherForm voucherType="SALES" /></PrivateRoute>} />
        <Route exact path={AccountsConstants.PURCHASE_CREATE} element={<PrivateRoute><VoucherEntry key="PURCHASE" voucherType="PURCHASE" /></PrivateRoute>} />
        <Route exact path={AccountsConstants.RECEIPT_CREATE} element={<PrivateRoute><VoucherEntry key="RECEIPT" voucherType="RECEIPT" /></PrivateRoute>} />
        <Route exact path={AccountsConstants.PAYMENT_CREATE} element={<PrivateRoute><VoucherEntry key="PAYMENT" voucherType="PAYMENT" /></PrivateRoute>} />
        <Route exact path={AccountsConstants.CREDIT_NOTE} element={<PrivateRoute><VoucherEntry key="CREDIT_NOTE" voucherType="CREDIT_NOTE" /></PrivateRoute>} />
        <Route exact path={AccountsConstants.DEBIT_NOTE} element={<PrivateRoute><VoucherEntry key="DEBIT_NOTE" voucherType="DEBIT_NOTE" /></PrivateRoute>} />
        <Route exact path={AccountsConstants.JOURNAL} element={<PrivateRoute><VoucherEntry key="JOURNAL" voucherType="JOURNAL" /></PrivateRoute>} />
        <Route exact path={AccountsConstants.CUSTOMERS} element={<PrivateRoute><CustomersPage /></PrivateRoute>} />
        <Route exact path={AccountsConstants.SALES_ORDERS} element={<PrivateRoute><SalesOrdersPage /></PrivateRoute>} />
        <Route exact path={AccountsConstants.LOADING_ADVICES} element={<PrivateRoute><LoadingAdvicesPage /></PrivateRoute>} />
        <Route exact path={AccountsConstants.SALES_INVOICES} element={<PrivateRoute><SalesInvoicesPage /></PrivateRoute>} />
        <Route exact path={AccountsConstants.VOUCHER_LIST} element={<PrivateRoute><VoucherList /></PrivateRoute>} />
        <Route exact path={AccountsConstants.VOUCHER_VIEW} element={<PrivateRoute><VoucherView /></PrivateRoute>} />
        <Route exact path={AccountsConstants.CHEQUES} element={<PrivateRoute><ChequeRegister /></PrivateRoute>} />
        <Route exact path={AccountsConstants.REPORTS} element={<PrivateRoute><LedgerStatement /></PrivateRoute>} />
        <Route exact path={AccountsConstants.LEDGER_STATEMENT} element={<PrivateRoute><LedgerStatement /></PrivateRoute>} />
        <Route exact path={AccountsConstants.DAY_BOOK} element={<PrivateRoute><DayBookPage /></PrivateRoute>} />
        <Route exact path={AccountsConstants.OUTSTANDING} element={<PrivateRoute><OutstandingPage /></PrivateRoute>} />
        <Route exact path="/accounts/reports/outstanding/:customerId" element={<PrivateRoute><CustomerOutstandingPage /></PrivateRoute>} />
        <Route exact path={AccountsConstants.AGING} element={<PrivateRoute><AgingPage /></PrivateRoute>} />
        <Route exact path={AccountsConstants.PAYABLES} element={<PrivateRoute><PayablesPage /></PrivateRoute>} />
        <Route exact path={AccountsConstants.PORTAL} element={<PrivateRoute><PortalPage /></PrivateRoute>} />
        {/*----------------------------------------ACCOUNTS  END--------------------------------------------------*/}
        {/*---------------------------------------------------Public Access------------------------------------------------*/}
        <Route
          exact
          path={SupplierConstantsList.MATERIAL_CATLOG_SHOWPWISE_V1}
          element={<MATERIAL_CATLOG_SHOWPWISE_V1 />}
        />
        <Route
          exact
          path={SupplierConstantsList.PUBLIC_TENDOR_LIST}
          element={<PUBLIC_TENDOR_LIST />}
        />
        <Route
          exact
          path={SupplierConstantsList.PUBLIC_QTN_CREATION}
          element={<PUBLIC_QTN_CREATION />}
        />
        <Route
          exact
          path={SupplierConstantsList.PUBLIC_TND_DETAILS}
          element={<PUBLIC_TND_DETAILS />}
        />
        <Route
          exact
          path={SupplierConstantsList.PUBLIC_QTN_VERSION_CREATION}
          element={<PUBLIC_QTN_VERSION_CREATION />}
        />
      </Routes>
      {/* <Footer/> */}
    </>
  );
}

export default AppRouters;
